import React, { useState, useContext, useEffect, Fragment } from "react";
import { Link, NavLink } from "react-router-dom";
import localization from "assets/localization/localization";
import { BaseUrl } from "contexts/baseUrl/baseUrl";
import { STATUS } from "constants/statusConstant";
import { connect } from "react-redux";

const DropDownLink = ({
  activeComponent,
  departmentId,
  teamId,
  role,
  siteInfoFeature,
  attCheckIn,
  attCheckInSite,
  userId,
  isApprovalAllowed,
  attendanceTabFlag,
  darwinManagerCheck,
  isJourneyStarted,
  ...props
}) => {
  const { baseUrl } = useContext(BaseUrl);
  const [activeLink, setActiveLink] = useState(false);
  // const [isRoleId, setIsRoleId] = useState(null);
  const [active, setActive] = useState(false);
  const [activeBusinessApproval, setActiveBusinessApproval] = useState(false);
  const [activePayment, setActivePayment] = useState(false);
  const [pmActive, setPmActive] = useState(false);
  const [activeMRF, setActiveMRF] = useState(false);
  const [mapActive, setMapActive] = useState(false);
  const [locationActive, setLocationActive] = useState(false);
  const [approvalActive, setApprovalActive] = useState(false);
  const [activeComplain, setActiveComplain] = useState(false);
  const [baActive, setBaActive] = useState(false);
  const [approve, setApprove] = useState(false);
  const [approveLocation, setApproveLocation] = useState(false);
  const [helpdesk, setHelpdesk] = useState(false);
  const [activeInfraValet, setActiveInfraValet] = useState(false);
  const [activeVendorPortal, setActiveVendorPortal] = useState(false);
  const [projectOnboard, setprojectOnboard] = useState(false);
  const [activeIncentive, setActiveIncentive] = useState(false);
  const [activeInstallation, setActiveInstallation] = useState(false);
  const [activeWallet, setActiveWallet] = useState(false);
  const [activeHoto, setActiveHoto] = useState(false);
  const [activePR, setActivePr] = useState(false);
  const [activeValetServiceLineItem, setActiveValetServiceLineItem] =
    useState(false);
  const [adsCampaign, setAdsCampaign] = useState(false);
  const [rating, setRating] = useState(false);
  const [scorecard, setScorecard] = useState(false);
  const [serviceLineItem, setServiceLineItem] = useState(false);
  const [activeTicket, setActiveTicket] = useState(false);
  const [carLoan, setCarLoan] = useState(false);
  const [offroleEmployee, setOffroleEmployee] = useState(false);
  const [creditData, setCreditData] = useState(false);
  const [activeBusinessItems, setActiveBusinessItems] = useState(false);
  const [channelPartner, setChannelPartner] = useState(false);
  const [activeAttendance, setActiveAttendance] = useState(false);

  const { isRoleId } = props;

  const handleApproveLocation = (flag) => {
    setApproveLocation(!approveLocation);
    localStorage.setItem("handleApproveLocation", flag);
  };

  const handleHelpdesk = (flag) => {
    setHelpdesk(!helpdesk);
    localStorage.setItem("handleHelpdesk", flag);
  };

  const handleActiveValetServiceLineItem = (flag) => {
    setActiveValetServiceLineItem(!activeValetServiceLineItem);
    localStorage.setItem("ActiveValetServiceLineItem", flag);
  };

  const handletServiceLineItem = (flag) => {
    setServiceLineItem(!serviceLineItem);
    localStorage.setItem("ServiceLineItem", flag);
  };

  const handleBaActive = (flag) => {
    setBaActive(!baActive);
    localStorage.setItem("handleBaActive", flag);
  };

  const handleAdsCampaign = (flag) => {
    setAdsCampaign(!adsCampaign);
    localStorage.setItem("handleAdsCampaign", flag);
  };

  const handleCreditPolicy = (flag) => {
    setCreditData(!creditData);
    localStorage.setItem("handleCreditPolicy", flag);
  };

  const handleApproveActive = (flag) => {
    setApprove(!approve);
    localStorage.setItem("handleApproveActive", flag);
  };

  const handleActive = (flag) => {
    setActive(!active);
    localStorage.setItem("handleActive", flag);
  };

  const handleActiveBusinessApproval = (flag) => {
    setActiveBusinessApproval(!activeBusinessApproval);
    localStorage.setItem("handleActiveBusinessApproval", flag);
  };

  const handleActivePr = (flag) => {
    setActivePr(!activePR);
    localStorage.setItem("handleActivePr", flag);
  };
  const handleIncentiveActive = (flag) => {
    setActiveIncentive(!activeIncentive);
    localStorage.setItem("handleIncentiveActive", flag);
  };
  const handleWalletActive = (flag) => {
    setActiveWallet(!activeWallet);
    localStorage.setItem("handleWalletActive", flag);
  };
  const handleActivePayment = (flag) => {
    setActivePayment(!activePayment);
    localStorage.setItem("handleActivePayment", flag);
  };
  const handleActiveOnboarding = (flag) => {
    setprojectOnboard(!activePayment);
    localStorage.setItem("handleActiveOnboard", flag);
  };

  const handleMapActive = (flag) => {
    setMapActive(!mapActive);
    localStorage.setItem("handleMapActive", flag);
  };

  const handleLocationActive = (flag) => {
    setLocationActive(!locationActive);
    localStorage.setItem("handleLocationActive", flag);
  };

  const handleApprovalActive = (flag) => {
    setApprovalActive(!approvalActive);
    localStorage.setItem("handleApprovalActive", flag);
  };

  const handlePmActive = (flag) => {
    setPmActive(!pmActive);
    localStorage.setItem("handlePmActive", flag);
  };

  const handleActiveMRF = (flag) => {
    setActiveMRF(!activeMRF);
    localStorage.setItem("handleActiveMRF", flag);
  };

  const handleActiveTickets = (flag) => {
    setActiveTicket(!activeTicket);
    localStorage.setItem("handleActiveTickets", flag);
  };

  const handleActiveBusinessItems = (flag) => {
    setActiveBusinessItems(!activeBusinessItems);
    localStorage.setItem("handleActiveBusinessItems", flag);
  };

  const handleActiveLink = (flag) => {
    setActiveLink(flag);
    setTimeout(() => {
      localStorage.setItem("handleActiveLink", flag);
    }, 1000);
  };

  const handleActiveInstallation = (flag) => {
    setActiveInstallation(flag);
    setTimeout(() => {
      localStorage.setItem("handleActiveInstallation", flag);
    }, 1000);
  };

  const handleActiveComplain = (flag) => {
    setActiveComplain(flag);
    setTimeout(() => {
      localStorage.setItem("setActiveComplain", flag);
    }, 1000);
  };
  const handleActiveVendorPortal = (flag) => {
    setActiveVendorPortal(!activeVendorPortal);
    localStorage.setItem("handleActiveVendorPortal", flag);
  };
  const handleRemove = () => {
    document.body.classList.remove("show-sidebar");
    localStorage.setItem("page", 1);
  };

  const handleRemoveNew = (menuName = null) => {
    // console.log(menuName);
    localStorage.setItem(menuName, 1);
    document.body.classList.remove("show-sidebar");
    localStorage.setItem("page", 1);
    localStorage.setItem("valetIncentivePage", 1);
  };

  const handleActiveInfraValet = (flag) => {
    setActiveInfraValet(!activeInfraValet);
    localStorage.setItem("handleActiveInfraValet", flag);
  };

  const handleHotoActive = (flag) => {
    setActiveHoto(!activeHoto);
    localStorage.setItem("handleHotoActive", flag);
  };

  const handleRating = (flag) => {
    setRating(!rating);
    localStorage.setItem("handleRating", flag);
  };

  const handleScorecard = (flag) => {
    setRating(!scorecard);
    localStorage.setItem("handleScorecard", flag);
  };

  const handleCarLoanActive = (flag) => {
    setCarLoan(!carLoan);
    localStorage.setItem("handleCarLoanActive", flag);
  };

  const handleChannelPartnerActive = (flag) => {
    setChannelPartner(!channelPartner);
    localStorage.setItem("handleChannelPartnerActive", flag);
  };

  const handleOffroleEmployeeActive = (flag) => {
    setOffroleEmployee(!offroleEmployee);
    localStorage.setItem("handleOffroleEmployeeActive", flag);
  };

  const handleActiveAttendance = (flag) => {
    setActiveAttendance(!activeAttendance);
    localStorage.setItem("handleActiveAttendance", flag);
  };

  useEffect(() => {
    if (localStorage.getItem("handleActive"))
      setActive(JSON.parse(localStorage.getItem("handleActive")));

    if (localStorage.getItem("handleActiveLink")) {
      setActiveLink(JSON.parse(localStorage.getItem("handleActiveLink")));
    }
  }, []);

  const handlePageReload = () => {
    // window.location.reload(false)
  };

  return (
    <Fragment>
      {(role.includes(7) || role.includes(17)) && (
        <li>
          <NavLink
            exact
            to={`${baseUrl}/performance-tracker`}
            onClick={handleRemove}
          >
            {localization.performanceTracker}
          </NavLink>
        </li>
      )}

      {departmentId.includes(3) && teamId.includes(4) && (
        <>
          <li>
            <NavLink
              exact
              to={`${baseUrl}/ba-dashboard`}
              onClick={handleRemove}
            >
              {localization.baDashboard}
            </NavLink>
          </li>
          <li>
            <NavLink
              exact
              to={`${baseUrl}/client-orders`}
              onClick={handleRemove}
            >
              {"Client Order"}
            </NavLink>
          </li>
        </>
      )}

      {departmentId.includes(3) && !role.includes(16) && !role.includes(17) && (
        <li>
          <NavLink
            exact
            to={`${baseUrl}/training-levels`}
            onClick={handleRemove}
          >
            {localization.training}
          </NavLink>
        </li>
      )}
      {role.includes(16) && (
        <li>
          <NavLink exact to={`${baseUrl}/add-checklist`} onClick={handleRemove}>
            {`Training Checklist`}
          </NavLink>
        </li>
      )}
      {(role.includes(16) || role.includes(17)) && (
        <li>
          <NavLink
            exact
            to={`${baseUrl}/master-assesment-history`}
            onClick={handleRemove}
          >
            {localization.assesmentResult}
          </NavLink>
        </li>
      )}
      {role.includes(2) && (
        <li>
          <NavLink
            exact
            to={`${baseUrl}/tutorial-listing`}
            onClick={handleRemove}
          >
            {localization.tutorialQuestion}
          </NavLink>
        </li>
      )}

      {role.includes(69) && (
        <li className={`treeview ${channelPartner === true ? "active" : ""}`}>
          <Link
            to="#"
            onClick={() => handleChannelPartnerActive(!channelPartner)}
          >
            {"Channel Partner"}
          </Link>
          <ul
            className={`treeview-menu ${
              channelPartner === true ? "d-block" : ""
            }`}
          >
            <li>
              <NavLink
                exact
                to={`${baseUrl}/handover-transfer`}
                onClick={handleRemove}
              >
                {"Transfer Handover"}
              </NavLink>
            </li>
            <li>
              <NavLink
                exact
                to={`${baseUrl}/invoice-visibility`}
                onClick={handleRemove}
              >
                {"Invoice Visibility"}
              </NavLink>
            </li>
          </ul>
        </li>
      )}

      {role.includes(62) && (
        <>
          <li className={`treeview ${carLoan === true ? "active" : ""}`}>
            <Link to="#" onClick={() => handleCarLoanActive(!carLoan)}>
              {"Car Loan"}
            </Link>
            <ul
              className={`treeview-menu ${carLoan === true ? "d-block" : ""}`}
            >
              <li>
                <NavLink
                  exact
                  to={`${baseUrl}/rc-transfer`}
                  onClick={handleRemove}
                >
                  {"RC Transfer"}
                </NavLink>
              </li>
              <li>
                <NavLink
                  exact
                  to={`${baseUrl}/ucd/rc-b2c-case-list`}
                  onClick={handleRemove}
                >
                  {"B2C Cases"}
                </NavLink>
              </li>
              <li>
                <NavLink
                  exact
                  to={`${baseUrl}/ucd/rc-b2b-case-list`}
                  onClick={handleRemove}
                >
                  {"B2B Cases"}
                </NavLink>
              </li>
              <li>
                <NavLink
                  exact
                  to={`${baseUrl}/ucd/rto/cases/list`}
                  onClick={handleRemove}
                >
                  {"Bank Cases"}
                </NavLink>
              </li>
            </ul>
          </li>
        </>
      )}

      {(attendanceTabFlag || darwinManagerCheck) && (
        <li className={`treeview ${activeAttendance === true ? "active" : ""}`}>
          <Link
            to="#"
            onClick={() => handleActiveAttendance(!activeAttendance)}
          >
            {localization.attendanceTab}
          </Link>
          <ul
            className={`treeview-menu ${
              activeAttendance === true ? "d-block" : ""
            }`}
          >
            {attendanceTabFlag && (
              <>
                {(!role.includes(9) || isJourneyStarted) && (
                  <li>
                    <NavLink
                      exact
                      to={`${baseUrl}/attendance/check-in-checkout`}
                      onClick={handleRemove}
                    >
                      {localization.checkInCheckout}
                    </NavLink>
                  </li>
                )}
                <li>
                  <NavLink
                    exact
                    to={`${baseUrl}/darwin-record`}
                    onClick={handleRemove}
                  >
                    Attendance Record
                  </NavLink>
                </li>
              </>
            )}
            {darwinManagerCheck && (
              <>
                <li>
                  <NavLink
                    exact
                    to={`${baseUrl}/darwin-record/regularizations/manager`}
                    onClick={handleRemove}
                  >
                    Regularization Requests
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    exact
                    to={`${baseUrl}/darwin-record/regularizations/employee`}
                    onClick={handleRemove}
                  >
                    Regularization Logs
                  </NavLink>
                </li>
              </>
            )}
          </ul>
        </li>
      )}

      {/* {!role.includes(9) &&
        (attCheckIn &&
        attCheckIn.length > 0 &&
        attCheckInSite &&
        attCheckInSite[0] &&
        attCheckInSite[0].type_id &&
        attCheckInSite[0].type_id == 1 ? (
          <li>
            <NavLink exact to={`${baseUrl}/check_out`} onClick={handleRemove}>
              {localization.checkOut}
            </NavLink>
          </li>
        ) : (
          attCheckIn &&
          attCheckIn.length > 0 && (
            <li>
              <NavLink exact to={`${baseUrl}/check_in`} onClick={handleRemove}>
                {localization.attendance}
              </NavLink>
            </li>
          )
        ))} */}

      {(role.includes(16) || role.includes(4)) && (
        <li>
          <NavLink
            exact
            to={`${baseUrl}/dynamic-contents`}
            onClick={handleRemove}
          >
            {localization.dynamicContents}
          </NavLink>
        </li>
      )}

      {teamId.includes(16) && (
        <li>
          <NavLink
            exact
            to={`${baseUrl}/employee-pos-stock`}
            onClick={handleRemove}
          >
            {localization.posStock}
          </NavLink>
        </li>
      )}

      {/* offrole employee tab starts */}
      {(role.includes(11) || role.includes(55)) && (
        <li className={`treeview ${offroleEmployee === true ? "active" : ""}`}>
          <Link
            to="#"
            onClick={() => handleOffroleEmployeeActive(!offroleEmployee)}
          >
            {localization.offroleEmployee}
          </Link>
          <ul
            className={`treeview-menu ${
              offroleEmployee === true ? "d-block" : ""
            }`}
          >
            <li>
              <NavLink
                exact
                to={`${baseUrl}/generate-link`}
                onClick={handleRemove}
              >
                {localization.generateLink}
              </NavLink>
            </li>
            <li>
              <NavLink
                exact
                to={`${baseUrl}/offrole-employees-list`}
                onClick={handleRemove}
              >
                {localization.employeesApprovalList}
              </NavLink>
            </li>
            <li>
              <NavLink
                exact
                to={`${baseUrl}/active-reactive-list`}
                onClick={handleRemove}
              >
                {localization.employeesOffboardOnboard}
              </NavLink>
            </li>
          </ul>
        </li>
      )}
      {/* offrole employee tab ends */}

      {departmentId.includes(3) && (
        <li className={`treeview ${active === true ? "active" : ""}`}>
          <Link to="#" onClick={() => handleActive(!active)}>
            {localization.project}
          </Link>
          <ul className={`treeview-menu ${active === true ? "d-block" : ""}`}>
            <li>
              <NavLink
                exact
                to={`${baseUrl}/business-lists`}
                onClick={handleRemove}
              >
                {localization.businessList}
              </NavLink>
            </li>
            <li>
              <NavLink
                exact
                to={`${baseUrl}/client-list-all`}
                onClick={handleRemove}
              >
                {localization.clientList}
              </NavLink>
            </li>
          </ul>
        </li>
      )}

      {(role.includes(54) ||
        role.includes(13) ||
        role.includes(49) ||
        role.includes(41) ||
        role.includes(72)) && (
        <li className={`treeview ${carLoan === true ? "active" : ""}`}>
          <Link to="#" onClick={() => handleCarLoanActive(!carLoan)}>
            {"Car Loan"}
          </Link>
          <ul className={`treeview-menu ${carLoan === true ? "d-block" : ""}`}>
            {/* only for business head */}
            {/*{role.includes(72) && (*/}
            <li>
              <NavLink
                exact
                to={`${baseUrl}/ucd/business-head-payout-list`}
                onClick={handleRemove}
              >
                {"Payout List"}
              </NavLink>
            </li>
            <li>
              <NavLink
                exact
                to={`${baseUrl}/ucd/commission-payout-list`}
                onClick={handleRemove}
              >
                {"Commission Payout Cases List"}
              </NavLink>
            </li>
            {/*)}*/}
            {/* dealer executive */}
            {role.includes(54) && (
              <>
                <li>
                  <NavLink
                    exact
                    to={`${baseUrl}/ucd/list`}
                    onClick={handleRemove}
                  >
                    {"B2B List"}
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    exact
                    to={`${baseUrl}/ucd/lead/logged-in`}
                    onClick={handleRemove}
                  >
                    {"B2C Logged In"}
                  </NavLink>
                </li>
                {/*{(userId.includes(886) || userId.includes(876))  && (*/}
                <li>
                  <NavLink
                    exact
                    to={`${baseUrl}/ucd/bank-sheet-upload`}
                    onClick={handleRemove}
                  >
                    {"Bank Sheet"}
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    exact
                    to={`${baseUrl}/ucd/bank-sheet-list`}
                    onClick={handleRemove}
                  >
                    {"Bank Sheet Request List"}
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    exact
                    to={`${baseUrl}/ucd/rto/cases/list`}
                    onClick={handleRemove}
                  >
                    {"Bank Cases"}
                  </NavLink>
                </li>
              </>
            )}

            {role.includes(41) && (
              <>
                <li>
                  <NavLink
                    exact
                    to={`${baseUrl}/ucd/list`}
                    onClick={handleRemove}
                  >
                    {"B2B List"}
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    exact
                    to={`${baseUrl}/ucd/b2c-lead-list`}
                    onClick={handleRemove}
                  >
                    {"B2C Leads"}
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    exact
                    to={`${baseUrl}/ucd/lead/logged-in`}
                    onClick={handleRemove}
                  >
                    {"B2C Logged In"}
                  </NavLink>
                </li>
              </>
            )}

            {/* finance head */}
            {role.includes(13) && (
              <>
                <li>
                  <NavLink
                    exact
                    to={`${baseUrl}/ucd/request-payment-release`}
                    onClick={handleRemove}
                  >
                    {"B2B Payment Release Request"}
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    exact
                    to={`${baseUrl}/ucd/bank-sheet-list`}
                    onClick={handleRemove}
                  >
                    {"Bank Sheet Request List"}
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    exact
                    to={`${baseUrl}/ucd/b2c-request-payment-release`}
                    onClick={handleRemove}
                  >
                    {"B2C Payment Release Request"}
                  </NavLink>
                </li>
                {/*{(userId.includes(886) || userId.includes(876)) && (*/}
                <li>
                  <NavLink
                    exact
                    to={`${baseUrl}/ucd/finance-head-payout-release-list`}
                    onClick={handleRemove}
                  >
                    {"Payout Release Request"}
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    exact
                    to={`${baseUrl}/ucd/rto/cases/list`}
                    onClick={handleRemove}
                  >
                    {"Bank Cases"}
                  </NavLink>
                </li>
                {/*)}*/}
              </>
            )}

            {/* finance director */}
            {role.includes(49) && (
              <>
                <li>
                  <NavLink
                    exact
                    to={`${baseUrl}/ucd/pending-payment`}
                    onClick={handleRemove}
                  >
                    {"B2B Pending Payment"}
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    exact
                    to={`${baseUrl}/ucd/bank-sheet-list`}
                    onClick={handleRemove}
                  >
                    {"Bank Sheet Request List"}
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    exact
                    to={`${baseUrl}/ucd/b2c-pending-payment`}
                    onClick={handleRemove}
                  >
                    {"B2C Pending Payment"}
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    exact
                    to={`${baseUrl}/ucd/approved-payment`}
                    onClick={handleRemove}
                  >
                    {"Disbursed"}
                  </NavLink>
                </li>
                {/*{(userId.includes(886) || userId.includes(876)) && (*/}
                <li>
                  <NavLink
                    exact
                    to={`${baseUrl}/ucd/finance-director-payout-list`}
                    onClick={handleRemove}
                  >
                    {"Payout Release Request"}
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    exact
                    to={`${baseUrl}/ucd/rto/cases/list`}
                    onClick={handleRemove}
                  >
                    {"Bank Cases"}
                  </NavLink>
                </li>
                {/*)}*/}
              </>
            )}
            {/*<li>*/}
            {/*  <NavLink*/}
            {/*      exact*/}
            {/*      to={`${baseUrl}/ucd/case-list`}*/}
            {/*      onClick={handleRemove}*/}
            {/*  >*/}
            {/*    {'Cases'}*/}
            {/*  </NavLink>*/}
            {/*</li>*/}
          </ul>
        </li>
      )}

      {departmentId.includes(4) && (
        <li className={`treeview ${active === true ? "active" : ""}`}>
          <Link to="#" onClick={() => handleActive(!active)}>
            {localization.finance}
          </Link>
          <ul className={`treeview-menu ${active === true ? "d-block" : ""}`}>
            <li>
              <NavLink
                exact
                to={`${baseUrl}/finance-business-list`}
                onClick={handleRemove}
              >
                {localization.businessList}
              </NavLink>
            </li>
            <li>
              <NavLink
                exact
                to={`${baseUrl}/client-list`}
                onClick={handleRemove}
              >
                {localization.clientList}
              </NavLink>
            </li>
            <li>
              <NavLink
                exact
                to={`${baseUrl}/finance-contract-listing`}
                onClick={handleRemove}
              >
                {localization.financeContract}
              </NavLink>
            </li>
            <li>
              <NavLink
                exact
                to={`${baseUrl}/site-dashboard`}
                onClick={handleRemove}
              >
                {localization.siteDashboard}
              </NavLink>
            </li>
            <li>
              <NavLink
                exact
                to={`${baseUrl}/abort-site-approvals-finance`}
                onClick={handleRemove}
              >
                {localization.siteActions}
              </NavLink>
            </li>
            <li>
              <NavLink
                exact
                to={`${baseUrl}/finance-mrf-list`}
                onClick={handleRemove}
              >
                {localization.mrfView}
              </NavLink>
            </li>
            <li>
              <NavLink
                exact
                to={`${baseUrl}/approval-listing-finance`}
                onClick={handleRemove}
              >
                {"Approved/Rejected List"}
              </NavLink>
            </li>
          </ul>
        </li>
      )}

      {/* Incentive Portal — hidden; APIs served by Laravel
      {departmentId.includes(4) && (
        <li className={`treeview ${activeIncentive === true ? "active" : ""}`}>
          <Link to="#" onClick={() => handleIncentiveActive(!activeIncentive)}>
            {localization.incenitvePortal}
          </Link>
          <ul
            className={`treeview-menu ${
              activeIncentive === true ? "d-block" : ""
            }`}
          >
            <li>
              <NavLink
                exact
                to={`${baseUrl}/incentive-list`}
                onClick={handleRemove}
              >
                {localization.incentiveList}
              </NavLink>
            </li>
            <li>
              <NavLink
                exact
                to={`${baseUrl}/user_incentives`}
                onClick={handleRemove}
              >
                {localization.userIncentives}
              </NavLink>
            </li>
            <li>
              <NavLink
                exact
                to={`${baseUrl}/senior_incentives`}
                onClick={handleRemove}
              >
                {localization.seniorIncentives}
              </NavLink>
            </li>
            <li>
              <NavLink
                exact
                to={`${baseUrl}/head_incentives`}
                onClick={handleRemove}
              >
                {localization.headIncentive}
              </NavLink>
            </li>
          </ul>
        </li>
      )}
      */}
      {role.includes(9) ? (
        <li>
          <NavLink
            exact
            to={`${baseUrl}/toolkit-inspection`}
            onClick={handleRemove}
          >
            {localization.toolkitInspection}
          </NavLink>
        </li>
      ) : null}

      {(userId.includes(258) || userId.includes(1218)) && (
        <li>
          <NavLink exact to={`${baseUrl}/lob-list`} onClick={handleRemove}>
            {localization.lob}
          </NavLink>
        </li>
      )}

      {(role.includes(3) ||
        role.includes(4) ||
        role.includes(5) ||
        role.includes(7) ||
        role.includes(6) ||
        role.includes(57) ||
        role.includes(16)) && (
        <>
          {teamId.includes(7) || teamId.includes(8) ? null : (
            <li
              className={`treeview ${projectOnboard === true ? "active" : ""}`}
            >
              <Link
                to="#"
                onClick={() => handleActiveOnboarding(!projectOnboard)}
              >
                {localization.projectOnboard}
              </Link>
              <ul
                className={`treeview-menu ${
                  projectOnboard === true ? "d-block" : ""
                }`}
              >
                {!role.includes(16) && (
                  <li>
                    <NavLink
                      exact
                      to={`${baseUrl}/project-onboarding/list`}
                      onClick={handleRemove}
                    >
                      {localization.projectList}
                    </NavLink>
                  </li>
                )}

                {/* {(userId.includes(357) || userId.includes(358)) && (     */}
                {((isRoleId !== null && isRoleId === STATUS.CITY_HEAD) ||
                  isRoleId === STATUS.SALES_COORDINATOR ||
                  isRoleId === STATUS.NATIONAL_HEAD ||
                  isRoleId === STATUS.NATIONAL_HEAD_OPERATIONS ||
                  isRoleId === 6) && (
                  <li>
                    <NavLink
                      exact
                      to={`${baseUrl}/lead_approvals`}
                      onClick={handleRemove}
                    >
                      {localization.leadApproval}
                    </NavLink>
                  </li>
                )}
              </ul>
            </li>
          )}
        </>
      )}
      {departmentId.includes(2) && (
        <li className={`treeview ${activeLink === true ? "active" : ""}`}>
          <Link to="#" onClick={() => handleActiveLink(!activeLink)}>
            {localization.sales}
          </Link>
          <ul
            className={`treeview-menu ${activeLink === true ? "d-block" : ""}`}
          >
            {/* <li>
              <NavLink
                exact
                to={`${baseUrl}/${activeComponent}`}
                onClick={handleRemove}
              >
                {localization.createLead}
              </NavLink>
            </li> */}
            <li className={`treeview ${active === true ? "active" : ""}`}>
              <Link to="#" onClick={() => handleActive(!active)}>
                {localization.leadListing}
              </Link>
              <ul
                className={`treeview-menu ${active === true ? "d-block" : ""}`}
              >
                {/* <li>
                  <NavLink
                    exact
                    to={`${baseUrl}/preSalesListing`}
                    onClick={handleRemove}
                  >
                    {localization.preSalesLeadListing}
                  </NavLink>
                </li> */}
                <li>
                  <NavLink
                    exact
                    to={`${baseUrl}/project-onboarding/list`}
                    onClick={handleRemove}
                  >
                    {localization.projectList}
                  </NavLink>
                </li>
                {isRoleId !== 55 && (
                  <>
                    <li>
                      <NavLink
                        exact
                        to={`${baseUrl}/postSalesListing`}
                        onClick={() => handleRemoveNew("businessListCont")}
                        // onClick={handleRemove}
                      >
                        {localization.postSalesLeadListing}
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        exact
                        to={`${baseUrl}/approved-sales-listing`}
                        onClick={handleRemove}
                      >
                        {localization.approvedSalesLeadListing}
                      </NavLink>
                    </li>
                  </>
                )}

                {/* Site Incentive — hidden; APIs served by Laravel
                {teamId.includes(8) &&
                  isRoleId !== STATUS.SALES_COORDINATOR &&
                  isRoleId !== 55 && (
                    <>
                      <li>
                        <NavLink
                          exact
                          to={`${baseUrl}/site_incentive_list`}
                          onClick={handleRemove}
                        >
                          {localization.incentiveLists}
                        </NavLink>
                      </li>
                    </>
                  )}
                */}
              </ul>
            </li>

            <li>
              <NavLink
                exact
                to={`${baseUrl}/sales-targets`}
                onClick={handleRemove}
              >
                {localization.targets}
              </NavLink>
            </li>

            <li
              className={`treeview ${
                activeBusinessApproval === true ? "active" : ""
              }`}
            >
              <Link
                to="#"
                onClick={() =>
                  handleActiveBusinessApproval(!activeBusinessApproval)
                }
              >
                {`Approvals`}
              </Link>
              <ul
                className={`treeview-menu ${
                  activeBusinessApproval === true ? "d-block" : ""
                }`}
              >
                {(teamId.includes(7) ||
                  teamId.includes(8) ||
                  teamId.includes(18)) && (
                  <>
                    {((isRoleId !== null && isRoleId === STATUS.CITY_HEAD) ||
                      isRoleId === STATUS.SALES_COORDINATOR ||
                      isRoleId === STATUS.NATIONAL_HEAD ||
                      isRoleId === STATUS.NATIONAL_HEAD_OPERATIONS ||
                      isRoleId === 6 ||
                      isRoleId === 55) && (
                      <li>
                        <NavLink
                          exact
                          to={`${baseUrl}/lead_approvals`}
                          onClick={handleRemove}
                        >
                          {localization.nonOnboardBusinessApproval}
                        </NavLink>
                      </li>
                    )}
                  </>
                )}
                {isRoleId !== null &&
                  (isRoleId === STATUS.SALES_COORDINATOR ||
                    isRoleId === STATUS.NATIONAL_HEAD) && (
                    <>
                      <li>
                        <NavLink
                          exact
                          to={`${baseUrl}/approvals`}
                          onClick={handleRemove}
                        >
                          {`Contract Approval`}
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          exact
                          to={`${baseUrl}/inspection_approvals`}
                          onClick={handleRemove}
                        >
                          {localization.inspectionApprovals}
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          exact
                          to={`${baseUrl}/tag_mismatch_approvals`}
                          onClick={handleRemove}
                        >
                          {localization.tagMismatchApproval}
                        </NavLink>
                      </li>
                      {/* Site Incentive — hidden; APIs served by Laravel
                      <li>
                        <NavLink
                          exact
                          to={`${baseUrl}/site_incentive`}
                          onClick={handleRemove}
                        >
                          {localization.siteIncentive}
                        </NavLink>
                      </li>
                      */}
                    </>
                  )}
                {isRoleId !== null && isRoleId === STATUS.SALES_COORDINATOR && (
                  <>
                    <li>
                      <NavLink
                        exact
                        to={`${baseUrl}/postpone-installation-approvals`}
                        onClick={handleRemove}
                      >
                        {localization.postponeInstallationApprovals}
                      </NavLink>
                    </li>
                  </>
                )}
              </ul>
            </li>
          </ul>
        </li>
      )}

      {(role.includes(17) || role.includes(46) || role.includes(4)) &&
        !departmentId.includes(2) && (
          <li className={`treeview ${activeLink === true ? "active" : ""}`}>
            <Link to="#" onClick={() => handleActiveLink(!activeLink)}>
              {localization.sales}
            </Link>
            <ul
              className={`treeview-menu ${activeLink === true ? "d-block" : ""}`}
            >
              {role.includes(46) && (
                <>
                  <li>
                    <NavLink
                      exact
                      to={`${baseUrl}/postSalesListing`}
                      onClick={() => handleRemoveNew("businessListCont")}
                      // onClick={handleRemove}
                    >
                      {localization.postSalesLeadListing}
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      exact
                      to={`${baseUrl}/approved-sales-listing`}
                      onClick={handleRemove}
                    >
                      {localization.approvedSalesLeadListing}
                    </NavLink>
                  </li>
                </>
              )}

              <li>
                <NavLink
                  exact
                  to={`${baseUrl}/sales-targets`}
                  onClick={handleRemove}
                >
                  {localization.targets}
                </NavLink>
              </li>

              {isRoleId !== null && isRoleId === STATUS.CITY_HEAD && (
                <>
                  <li>
                    <NavLink
                      exact
                      to={`${baseUrl}/approvals`}
                      onClick={handleRemove}
                    >
                      {localization.approvals}
                    </NavLink>
                  </li>
                </>
              )}
            </ul>
          </li>
        )}

      {(departmentId.includes(2) ||
        role.includes(14) ||
        role.includes(56) ||
        role.includes(16) ||
        role.includes(17) ||
        role.includes(15) ||
        role.includes(46) ||
        role.includes(47) ||
        role.includes(52) ||
        role.includes(51)) && (
        <li className={`treeview ${activePayment === true ? "active" : ""}`}>
          <Link to="#" onClick={() => handleActivePayment(!activePayment)}>
            {localization.paymentPortal}
          </Link>
          <ul
            className={`treeview-menu ${
              activePayment === true ? "d-block" : ""
            }`}
          >
            <li>
              <NavLink
                exact
                to={`${baseUrl}/businessList`}
                onClick={handleRemove}
              >
                {localization.businessList}
              </NavLink>
            </li>
            <li>
              <NavLink
                exact
                to={`${baseUrl}/taxInvoice`}
                onClick={handleRemove}
              >
                {localization.taxInv}
              </NavLink>
            </li>
            <li>
              <NavLink
                exact
                to={`${baseUrl}/taxInvoiceLob`}
                onClick={handleRemove}
              >
                {localization.taxInvLob}
              </NavLink>
            </li>
            <li>
              <NavLink
                exact
                to={`${baseUrl}/performaInvoice`}
                onClick={handleRemove}
              >
                {localization.performaInv}
              </NavLink>
            </li>
            <li>
              <NavLink
                exact
                to={`${baseUrl}/paymentRequest`}
                onClick={handleRemove}
              >
                {localization.PaymentRequestList}
              </NavLink>
            </li>
          </ul>
        </li>
      )}
      {role.includes(26) || role.includes(47) ? (
        <li className={`treeview ${activeInfraValet === true ? "active" : ""}`}>
          <Link
            to="#"
            onClick={() => handleActiveInfraValet(!activeInfraValet)}
          >
            {localization.valet}
          </Link>
          <ul
            className={`treeview-menu ${
              activeInfraValet === true ? "d-block" : ""
            }`}
          >
            {(role.includes(26) || role.includes(47)) && (
              <li>
                <NavLink
                  exact
                  to={`${baseUrl}/site-lead-referral`}
                  onClick={handleRemove}
                >
                  {localization.siteLeadReferral}
                </NavLink>
              </li>
            )}
            {(role.includes(26) || role.includes(47)) && (
              <li>
                <NavLink
                  exact
                  to={`${baseUrl}/client-client-referral`}
                  onClick={handleRemove}
                >
                  {localization.valetReferralTrackingDashboard}
                </NavLink>
              </li>
            )}
            {(role.includes(26) || role.includes(47)) && (
              <>
                <li>
                  <NavLink
                    exact
                    to={`${baseUrl}/valet-user-listing`}
                    onClick={() => handleRemoveNew("incentiveCount")}
                  >
                    {localization.incentiveApproval}
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    exact
                    to={`${baseUrl}/all-valet-listing`}
                    onClick={handleRemove}
                  >
                    {"All Valet List"}
                  </NavLink>
                </li>
                {role.includes(26) && (
                  <li>
                    <NavLink
                      exact
                      to={`${baseUrl}/attendance-master-list`}
                      onClick={handleRemove}
                    >
                      {"Attendance Master List"}
                    </NavLink>
                  </li>
                )}
                <li>
                  <NavLink
                    exact
                    to={`${baseUrl}/all-supervisor-listing`}
                    onClick={handleRemove}
                  >
                    {"All Supervisor List"}
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    exact
                    to={`${baseUrl}/supervisorList`}
                    onClick={handleRemove}
                  >
                    {localization.supervisorList}
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    exact
                    to={`${baseUrl}/valetList`}
                    onClick={handleRemove}
                  >
                    {localization.valet}
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    exact
                    to={`${baseUrl}/valet-chat-list`}
                    onClick={handleRemove}
                  >
                    {localization.raiseTicket}
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    exact
                    to={`${baseUrl}/project`}
                    onClick={handleRemove}
                  >
                    {localization.addProject}
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    exact
                    to={`${baseUrl}/incentive-slab`}
                    onClick={handleRemove}
                  >
                    {localization.incentivelab}
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    exact
                    to={`${baseUrl}/infra-zone-listing`}
                    onClick={handleRemove}
                  >
                    {localization.zone}
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    exact
                    to={`${baseUrl}/save-tag`}
                    onClick={handleRemove}
                  >
                    {localization.tagCount}
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    exact
                    to={`${baseUrl}/tag-list`}
                    onClick={handleRemove}
                  >
                    {localization.tagList}
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    exact
                    to={`${baseUrl}/salary-master`}
                    onClick={handleRemove}
                  >
                    {localization.salaryMaster}
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    exact
                    to={`${baseUrl}/event-salary`}
                    onClick={handleRemove}
                  >
                    {localization.eventSalary}
                  </NavLink>
                </li>
                {role.includes(26) && (
                  <li>
                    <NavLink
                      exact
                      to={`${baseUrl}/advance-salary/list`}
                      onClick={handleRemove}
                    >
                      {localization.advanceSalary}
                    </NavLink>
                  </li>
                )}
                <li>
                  <NavLink
                    exact
                    to={`${baseUrl}/valet-salary`}
                    onClick={handleRemove}
                  >
                    {localization.holidayView}
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    exact
                    to={`${baseUrl}/internal-communication`}
                    onClick={() => handleRemove}
                  >
                    {localization.internalCommunication}
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    exact
                    to={`${baseUrl}/suggest-master-salary-penalty`}
                    onClick={() => handleRemove}
                  >
                    {"Suggest Penalty"}
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    exact
                    to={`${baseUrl}/getMonthlyData`}
                    onClick={handleRemove}
                  >
                    {localization.abscondDrivers}
                  </NavLink>
                </li>
              </>
            )}
          </ul>
        </li>
      ) : null}

      {role.includes(76) ? (
        <li className={`treeview ${activeInfraValet === true ? "active" : ""}`}>
          <Link
            to="#"
            onClick={() => handleActiveInfraValet(!activeInfraValet)}
          >
            {localization.valet}
          </Link>
          <ul
            className={`treeview-menu ${
              activeInfraValet === true ? "d-block" : ""
            }`}
          >
            <li>
              <NavLink exact to={`${baseUrl}/valetList`} onClick={handleRemove}>
                {localization.valet}
              </NavLink>
            </li>
            <li>
              <NavLink
                exact
                to={`${baseUrl}/supervisorList`}
                onClick={handleRemove}
              >
                {localization.supervisorList}
              </NavLink>
            </li>
            <li>
              <NavLink
                exact
                to={`${baseUrl}/suggest-master-salary-penalty`}
                onClick={() => handleRemove}
              >
                {"Suggest Penalty"}
              </NavLink>
            </li>
            <li>
              <NavLink
                exact
                to={`${baseUrl}/attendance-request-list`}
                onClick={() => handleRemove}
              >
                {"Approve Attendance"}
              </NavLink>
            </li>
            <li></li>
          </ul>
        </li>
      ) : null}

      {/* Vendor Portal */}
      {role.includes(3) ||
      role.includes(13) ||
      role.includes(19) ||
      role.includes(20) ||
      role.includes(21) ||
      role.includes(22) ||
      role.includes(23) ||
      role.includes(24) ||
      role.includes(25) ||
      role.includes(11) ||
      role.includes(12) ||
      role.includes(34) ||
      role.includes(32) ||
      role.includes(16) ||
      role.includes(39) ||
      role.includes(40) ||
      role.includes(15) ||
      role.includes(4) ||
      role.includes(5) ||
      role.includes(7) ||
      role.includes(56) ||
      role.includes(14) ||
      role.includes(9) ||
      role.includes(26) ||
      role.includes(44) ||
      role.includes(38) ||
      role.includes(49) ||
      role.includes(36) ||
      role.includes(46) ||
      role.includes(54) ||
      role.includes(55) ||
      role.includes(17) ||
      role.includes(52) ||
      role.includes(83) ? (
        <li
          className={`treeview ${activeVendorPortal === true ? "active" : ""}`}
        >
          <Link
            to="#"
            onClick={() => handleActiveVendorPortal(!activeVendorPortal)}
          >
            {localization.vendorPortal}
          </Link>
          <ul
            className={`treeview-menu ${
              activeVendorPortal === true ? "d-block" : ""
            }`}
          >
            {role.includes(13) ||
            role.includes(19) ||
            role.includes(21) ||
            role.includes(23) ||
            role.includes(25) ||
            role.includes(12) ||
            role.includes(34) ||
            role.includes(32) ||
            role.includes(16) ||
            role.includes(39) ||
            role.includes(40) ||
            role.includes(4) ||
            role.includes(7) ||
            role.includes(14) ||
            role.includes(56) ||
            role.includes(15) ||
            role.includes(9) ||
            role.includes(26) ||
            role.includes(44) ||
            role.includes(38) ||
            role.includes(5) ||
            role.includes(24) ||
            role.includes(36) ||
            role.includes(46) ||
            role.includes(54) ||
            role.includes(52) ||
            role.includes(11) ||
            role.includes(83) ? (
              <>
                {!role.includes(54) ? (
                  <li>
                    <NavLink
                      exact
                      to={`${baseUrl}/vendorRequestList`}
                      onClick={handleRemove}
                    >
                      {localization.vendorReq}
                    </NavLink>
                  </li>
                ) : null}

                <li>
                  <NavLink
                    exact
                    to={`${baseUrl}/vendorOnboardedList`}
                    onClick={handleRemove}
                  >
                    {localization.vendoronboard}
                  </NavLink>
                </li>

                {isApprovalAllowed.includes(true) && (
                  <li>
                    <NavLink
                      exact
                      to={`${baseUrl}/vendorOnboardedList?status=pending`}
                      onClick={handleRemove}
                    >
                      {localization.vendorPendingApprovalRequests}
                    </NavLink>
                  </li>
                )}

                {/* <li>
              <NavLink
                exact
                to={`${baseUrl}/vendorPaymentList`}
                onClick={handleRemove}
              >
                {localization.vendorPaymentList}
              </NavLink>
            </li> */}

                <li>
                  <NavLink
                    exact
                    to={`${baseUrl}/vendorPaymentRequestList`}
                    onClick={handleRemove}
                  >
                    {localization.vendorPaymentRequest}
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    exact
                    to={`${baseUrl}/invoice-request-list`}
                    onClick={handleRemove}
                  >
                    {localization.paymentInvoiceRequestList}
                  </NavLink>
                </li>
              </>
            ) : null}
            {role.includes(3) ||
            role.includes(20) ||
            role.includes(22) ||
            role.includes(24) ||
            role.includes(11) ||
            role.includes(16) ||
            role.includes(40) ||
            role.includes(44) ||
            role.includes(49) ||
            role.includes(4) ||
            role.includes(55) ||
            role.includes(17) ||
            role.includes(55) ||
            role.includes(52) ||
            role.includes(38) ||
            role.includes(83) ? (
              <li>
                <NavLink
                  exact
                  to={`${baseUrl}/vendorPaymentRequestApprovalList`}
                  onClick={handleRemove}
                >
                  {localization.vendorPaymentRequestApprovalList}
                </NavLink>
              </li>
            ) : null}
          </ul>
        </li>
      ) : null}
      {/* END Vendor Portal */}

      {/* city head operation = 17, national head operation = 16, ABM  = 46 for team valet 21*/}
      {teamId.includes(21) && (
        <>
          <li
            className={`treeview ${
              activeInstallation === true ? "active" : ""
            }`}
          >
            <Link
              to="#"
              onClick={() => handleActiveInstallation(!activeInstallation)}
            >
              {localization.installation}
            </Link>
            <ul
              className={`treeview-menu ${
                activeInstallation === true ? "d-block" : ""
              }`}
            >
              <li>
                <NavLink
                  exact
                  to={`${baseUrl}/site-listing`}
                  onClick={() => handleRemoveNew("installationCont")}
                >
                  {localization.siteList}
                </NavLink>
              </li>
            </ul>
          </li>
        </>
      )}
      {/* Parking Team */}
      {role.includes(38) || role.includes(37) || role.includes(36) ? (
        <>
          {role.includes(38) || role.includes(37) ? (
            <>
              <li
                className={`treeview ${
                  activeInstallation === true ? "active" : ""
                }`}
              >
                <Link
                  to="#"
                  onClick={() => handleActiveInstallation(!activeInstallation)}
                >
                  {localization.installation}
                </Link>
                <ul
                  className={`treeview-menu ${
                    activeInstallation === true ? "d-block" : ""
                  }`}
                >
                  <li>
                    <NavLink
                      exact
                      to={`${baseUrl}/site-listing`}
                      // onClick={handleRemove}
                      onClick={() => handleRemoveNew("installationCont")}
                    >
                      {localization.siteList}
                    </NavLink>
                  </li>

                  <li>
                    <NavLink
                      exact
                      to={`${baseUrl}/public-sites`}
                      // onClick={handleRemove}
                      onClick={() => handleRemoveNew("parkingSites")}
                    >
                      {localization.parkingSites}
                    </NavLink>
                  </li>
                </ul>
              </li>
              {role.includes(37) ? (
                <>
                  <li
                    className={`treeview ${pmActive === true ? "d-block" : ""}`}
                  >
                    <Link to="#" onClick={() => handlePmActive(!pmActive)}>
                      {localization.preventiveMaintenance}
                    </Link>
                    <ul
                      className={`treeview-menu ${
                        pmActive === true ? "d-block" : ""
                      }`}
                    >
                      <li>
                        <NavLink
                          exact
                          to={`${baseUrl}/pm-sities`}
                          onClick={() => handleRemoveNew("pmSiteCont")}
                          // onClick={handleRemove}
                        >
                          {localization.pmSities}
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          exact
                          to={`${baseUrl}/pm-software-sites`}
                          // onClick={handleRemove}
                          onClick={() => handleRemoveNew("pmSoftwareSites")}
                        >
                          {localization.PmSoftwareMaintenanceSites}
                        </NavLink>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <NavLink
                      exact
                      to={`${baseUrl}/rm-tickets`}
                      // onClick={handleRemove}
                      onClick={() => handleRemoveNew("rmTicketCont")}
                    >
                      {localization.reactiveMaintenance}
                    </NavLink>
                  </li>
                </>
              ) : null}
            </>
          ) : null}
          {role.includes(38) ? (
            <>
              <li className={`treeview ${active === true ? "active" : ""}`}>
                <Link to="#" onClick={() => handleActive(!active)}>
                  {localization.maintenance}
                </Link>
                <ul
                  className={`treeview-menu ${
                    active === true ? "d-block" : ""
                  }`}
                >
                  <li>
                    <NavLink
                      exact
                      to={`${baseUrl}/go-live-site`}
                      // onClick={handleRemove}
                      onClick={() => handleRemoveNew("mainSiteCont")}
                    >
                      {localization.goLiveSites}
                    </NavLink>
                  </li>

                  <li>
                    <NavLink
                      exact
                      to={`${baseUrl}/site-listing-maintenance`}
                      // onClick={handleRemove}
                      onClick={() => handleRemoveNew("mainSiteCont")}
                    >
                      {localization.contractListing}
                    </NavLink>
                  </li>
                  <li
                    className={`treeview ${pmActive === true ? "d-block" : ""}`}
                  >
                    <Link to="#" onClick={() => handlePmActive(!pmActive)}>
                      {localization.preventiveMaintenance}
                    </Link>
                    <ul
                      className={`treeview-menu ${
                        pmActive === true ? "d-block" : ""
                      }`}
                    >
                      <li>
                        <NavLink
                          exact
                          to={`${baseUrl}/pm-sities`}
                          onClick={() => handleRemoveNew("pmSiteCont")}
                          // onClick={handleRemove}
                        >
                          {localization.pmSities}
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          exact
                          to={`${baseUrl}/pm-software-sites`}
                          // onClick={handleRemove}
                          onClick={() => handleRemoveNew("pmSoftwareSites")}
                        >
                          {localization.PmSoftwareMaintenanceSites}
                        </NavLink>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <NavLink
                      exact
                      to={`${baseUrl}/rm-tickets`}
                      // onClick={handleRemove}
                      onClick={() => handleRemoveNew("rmTicketCont")}
                    >
                      {localization.reactiveMaintenance}
                    </NavLink>
                  </li>
                </ul>
              </li>
              <li
                className={`treeview ${
                  approvalActive === true ? "d-block" : ""
                }`}
              >
                <Link
                  to="#"
                  onClick={() => handleApprovalActive(!approvalActive)}
                >
                  {localization.approvals}
                </Link>
                <ul
                  className={`treeview-menu ${
                    approvalActive === true ? "d-block" : ""
                  }`}
                >
                  <li>
                    <NavLink
                      exact
                      to={`${baseUrl}/approvals/pm-sites`}
                      //  onClick={handleRemove}
                      onClick={() => handleRemoveNew("pmSiteCont")}
                    >
                      {localization.pmSities}
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      exact
                      to={`${baseUrl}/approvals/pm-software-approve-report`}
                      //  onClick={handleRemove}
                      onClick={() => handleRemoveNew("pmSoftwareSites")}
                    >
                      {localization.PmSoftwareMaintenanceSites}
                    </NavLink>
                  </li>

                  {/* <li>
              <NavLink
                exact
                to={`${baseUrl}/approvals/pm-tickets`}
                onClick={handleRemove}
              >
                {localization.pmTickets}
              </NavLink>
            </li> */}

                  <li>
                    <NavLink
                      exact
                      to={`${baseUrl}/approvals/rm-tickets`}
                      //  onClick={handleRemove}
                      onClick={() => handleRemoveNew("rmTicketCont")}
                    >
                      {localization.rmTickets}
                    </NavLink>
                  </li>

                  <li>
                    <NavLink
                      exact
                      to={`${baseUrl}/approvals/employee-ticket-list`}
                      onClick={handleRemove}
                    >
                      {localization.employeeTickets}
                    </NavLink>
                  </li>
                </ul>
              </li>
            </>
          ) : null}
          {role.includes(38) || role.includes(36) ? (
            <>
              <li
                className={`treeview ${
                  projectOnboard === true ? "active" : ""
                }`}
              >
                <Link
                  to="#"
                  onClick={() => handleActiveOnboarding(!projectOnboard)}
                >
                  {localization.projectOnboard}
                </Link>
                <ul
                  className={`treeview-menu ${
                    projectOnboard === true ? "d-block" : ""
                  }`}
                >
                  {!role.includes(16) && (
                    <li>
                      <NavLink
                        exact
                        to={`${baseUrl}/project-onboarding/list`}
                        onClick={handleRemove}
                      >
                        {localization.projectList}
                      </NavLink>
                    </li>
                  )}

                  {/* {(userId.includes(357) || userId.includes(358)) && (     */}
                  {isRoleId !== null &&
                    isRoleId === STATUS.PARKING_TEAM_CORDINATOR && (
                      <li>
                        <NavLink
                          exact
                          to={`${baseUrl}/lead_approvals`}
                          onClick={handleRemove}
                        >
                          {localization.leadApproval}
                        </NavLink>
                      </li>
                    )}
                </ul>
              </li>
              <li className={`treeview ${activeLink === true ? "active" : ""}`}>
                <Link to="#" onClick={() => handleActiveLink(!activeLink)}>
                  {localization.sales}
                </Link>
                <ul
                  className={`treeview-menu ${
                    activeLink === true ? "d-block" : ""
                  }`}
                >
                  <li className={`treeview ${active === true ? "active" : ""}`}>
                    <Link to="#" onClick={() => handleActive(!active)}>
                      {localization.leadListing}
                    </Link>
                    <ul
                      className={`treeview-menu ${
                        active === true ? "d-block" : ""
                      }`}
                    >
                      <li>
                        <NavLink
                          exact
                          to={`${baseUrl}/postSalesListing`}
                          onClick={() => handleRemoveNew("businessListCont")}
                          // onClick={handleRemove}
                        >
                          {localization.postSalesLeadListing}
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          exact
                          to={`${baseUrl}/approved-sales-listing`}
                          onClick={handleRemove}
                        >
                          {localization.approvedSalesLeadListing}
                        </NavLink>
                      </li>
                    </ul>
                  </li>

                  <li>
                    <NavLink
                      exact
                      to={`${baseUrl}/sales-targets`}
                      onClick={handleRemove}
                    >
                      {localization.targets}
                    </NavLink>
                  </li>

                  {teamId.includes(9) && <></>}
                  {isRoleId !== null &&
                    (isRoleId === STATUS.PARKING_TEAM_CORDINATOR ||
                      isRoleId === STATUS.NATIONAL_HEAD) && (
                      <>
                        <li>
                          <NavLink
                            exact
                            to={`${baseUrl}/approvals`}
                            onClick={handleRemove}
                          >
                            {localization.approvals}
                          </NavLink>
                        </li>
                        <li>
                          <NavLink
                            exact
                            to={`${baseUrl}/inspection_approvals`}
                            onClick={handleRemove}
                          >
                            {localization.inspectionApprovals}
                          </NavLink>
                        </li>
                      </>
                    )}
                </ul>
              </li>
              <li
                className={`treeview ${activePayment === true ? "active" : ""}`}
              >
                <Link
                  to="#"
                  onClick={() => handleActivePayment(!activePayment)}
                >
                  {localization.paymentPortal}
                </Link>
                <ul
                  className={`treeview-menu ${
                    activePayment === true ? "d-block" : ""
                  }`}
                >
                  <li>
                    <NavLink
                      exact
                      to={`${baseUrl}/businessList`}
                      onClick={handleRemove}
                    >
                      {localization.businessList}
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      exact
                      to={`${baseUrl}/taxInvoice`}
                      onClick={handleRemove}
                    >
                      {localization.taxInv}
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      exact
                      to={`${baseUrl}/performaInvoice`}
                      onClick={handleRemove}
                    >
                      {localization.performaInv}
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      exact
                      to={`${baseUrl}/paymentRequest`}
                      onClick={handleRemove}
                    >
                      {localization.PaymentRequestList}
                    </NavLink>
                  </li>
                </ul>
              </li>
            </>
          ) : null}
        </>
      ) : null}

      {/* END Parking Team */}

      {/* NEW MENU */}
      {role.includes(10) || role.includes(9) || role.includes(16) ? (
        <li>
          <NavLink
            exact
            to={`${baseUrl}/inspection-requests`}
            onClick={() => handleRemoveNew("pmSiteCont")}
            // onClick={handleRemove}
          >
            Business Configuration
          </NavLink>
        </li>
      ) : (
        <></>
      )}

      {role.includes(100) ? (
        <Fragment>
          {console.log(attCheckInSite)}
          {attCheckInSite &&
          attCheckInSite[0] &&
          attCheckInSite[0].lead_id &&
          attCheckInSite[0].lead_id > 0 &&
          attCheckInSite[0].location_type_id === 1 ? (
            attCheckInSite &&
            attCheckInSite[0] &&
            attCheckInSite[0].lead_id &&
            attCheckInSite[0].purpose === "Installation" ? (
              <>
                {/* AFTER CHECKIN */}
                <li>
                  <NavLink
                    exact
                    to={`${baseUrl}/task-listing`}
                    onClick={handleRemove}
                  >
                    {localization.siteList}
                  </NavLink>
                </li>
              </>
            ) : (
              departmentId.includes(3) &&
              teamId.includes(2) && (
                <>
                  <li className={`treeview ${active === true ? "active" : ""}`}>
                    <Link to="#" onClick={() => handleActive(!active)}>
                      {localization.maintenance}
                    </Link>
                    <ul
                      className={`treeview-menu ${
                        active === true ? "d-block" : ""
                      }`}
                    >
                      <li>
                        <NavLink
                          exact
                          to={`${baseUrl}/go-live-site`}
                          // onClick={handleRemove}
                          onClick={() => handleRemoveNew("mainSiteCont")}
                        >
                          {localization.goLiveSites}
                        </NavLink>
                      </li>

                      <li>
                        <NavLink
                          exact
                          to={`${baseUrl}/site-listing-maintenance`}
                          // onClick={handleRemove}
                          onClick={() => handleRemoveNew("mainSiteCont")}
                        >
                          {localization.contractListing}
                        </NavLink>
                      </li>
                      <li
                        className={`treeview ${
                          pmActive === true ? "d-block" : ""
                        }`}
                      >
                        <Link to="#" onClick={() => handlePmActive(!pmActive)}>
                          {localization.preventiveMaintenance}
                        </Link>
                        <ul
                          className={`treeview-menu ${
                            pmActive === true ? "d-block" : ""
                          }`}
                        >
                          <li>
                            <NavLink
                              exact
                              to={`${baseUrl}/pm-sities`}
                              onClick={() => handleRemoveNew("pmSiteCont")}
                              // onClick={handleRemove}
                            >
                              {localization.pmSities}
                            </NavLink>
                          </li>
                        </ul>
                      </li>
                      <li>
                        <NavLink
                          exact
                          to={`${baseUrl}/rm-tickets`}
                          // onClick={handleRemove}
                          onClick={() => handleRemoveNew("rmTicketCont")}
                        >
                          {localization.reactiveMaintenance}
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          exact
                          to={`${baseUrl}/contract-assets-mapping`}
                          // onClick={handleRemove}
                        >
                          {`Asset Verification`}
                        </NavLink>
                      </li>
                    </ul>
                  </li>
                  <li
                    className={`treeview ${activePR === true ? "active" : ""}`}
                  >
                    <Link to="#" onClick={() => handleActivePr(!activePR)}>
                      {localization.servicePr}
                    </Link>
                    <ul
                      className={`treeview-menu ${
                        activePR === true ? "d-block" : ""
                      }`}
                    >
                      <li>
                        <NavLink
                          exact
                          to={`${baseUrl}/additional-service-pr`}
                          // onClick={handleRemove}
                          onClick={() => handleRemoveNew("mainSiteCont")}
                        >
                          {localization.additionalServicePr}
                        </NavLink>
                      </li>
                    </ul>
                  </li>
                </>
              )
            )
          ) : (
            <>
              {/* ROLE 9 but Skip */}
              {attCheckIn && attCheckIn.length > 0 ? (
                <>
                  {departmentId.includes(3) && teamId.includes(1) && (
                    <li
                      className={`treeview ${
                        activeLink === true ? "active" : ""
                      }`}
                    >
                      <Link
                        to="#"
                        onClick={() => handleActiveLink(!activeLink)}
                      >
                        {localization.installation}
                      </Link>
                      <ul
                        className={`treeview-menu ${
                          activeLink === true ? "d-block" : ""
                        }`}
                      >
                        <li>
                          <NavLink
                            exact
                            to={`${baseUrl}/site-listing`}
                            // onClick={handleRemove}
                            onClick={() => handleRemoveNew("installationCont")}
                          >
                            {localization.siteList}
                          </NavLink>
                        </li>

                        {isRoleId !== 9 && (
                          <li>
                            <NavLink
                              exact
                              to={`${baseUrl}/site-engineer-list`}
                              onClick={handleRemove}
                            >
                              {localization.manageSiteEngineer}
                            </NavLink>
                          </li>
                        )}
                      </ul>
                    </li>
                  )}
                  {departmentId.includes(3) && teamId.includes(2) && (
                    <li
                      className={`treeview ${
                        pmActive === true ? "d-block" : ""
                      }`}
                    >
                      <Link to="#" onClick={() => handlePmActive(!pmActive)}>
                        {localization.preventiveMaintenance}
                      </Link>
                      <ul
                        className={`treeview-menu ${
                          pmActive === true ? "d-block" : ""
                        }`}
                      >
                        <li>
                          <NavLink
                            exact
                            to={`${baseUrl}/pm-sities`}
                            // onClick={handleRemove}
                            onClick={() => handleRemoveNew("pmSiteCont")}
                          >
                            {localization.pmSities}
                          </NavLink>
                        </li>
                        <li>
                          <NavLink
                            exact
                            to={`${baseUrl}/pm-software-sites`}
                            // onClick={handleRemove}
                            onClick={() => handleRemoveNew("pmSoftwareSites")}
                          >
                            {localization.PmSoftwareMaintenanceSites}
                          </NavLink>
                        </li>
                      </ul>
                      <li>
                        <NavLink
                          exact
                          to={`${baseUrl}/rm-tickets`}
                          // onClick={handleRemove}
                          onClick={() => handleRemoveNew("rmTicketCont")}
                        >
                          {localization.reactiveMaintenance}
                        </NavLink>
                      </li>
                    </li>
                  )}
                </>
              ) : null}
            </>
          )}
        </Fragment>
      ) : (
        <Fragment>
          <>
            {departmentId.includes(3) && teamId.includes(1) && (
              <>
                <li
                  className={`treeview ${activeLink === true ? "active" : ""}`}
                >
                  <Link to="#" onClick={() => handleActiveLink(!activeLink)}>
                    {localization.installation}
                  </Link>
                  <ul
                    className={`treeview-menu ${
                      activeLink === true ? "d-block" : ""
                    }`}
                  >
                    <li>
                      <NavLink
                        exact
                        to={`${baseUrl}/site-listing`}
                        onClick={() => handleRemoveNew("installationCont")}
                      >
                        {localization.siteList}
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        exact
                        to={`${baseUrl}/site-asset-mapping`}
                        onClick={() => handleRemoveNew("siteAssetMapping")}
                      >
                        {localization.assetMapingOld}
                      </NavLink>
                    </li>
                    {/* <li>
                        <NavLink
                            exact
                            to={`${baseUrl}/test-scanner`}
                            onClick={() => handleRemoveNew('siteAssetMapping')}
                        >
                          {`Scanner`}
                        </NavLink>
                      </li> */}
                    {isRoleId == 9 && (
                      <>
                        <li>
                          <NavLink
                            exact
                            to={`${baseUrl}/tasks_engg`}
                            //  onClick={handleRemove}
                            onClick={() =>
                              handleRemoveNew("networkEngineerTask")
                            }
                          >
                            {localization.networkEngineerTask}
                          </NavLink>
                        </li>
                        <li>
                          <NavLink
                            exact
                            to={`${baseUrl}/site-listing-engg`}
                            //  onClick={handleRemove}
                            onClick={() => handleRemoveNew("projectUpdates")}
                          >
                            {localization.projectsUpdates}
                          </NavLink>
                        </li>
                      </>
                    )}

                    {isRoleId !== 9 && (
                      <li>
                        <NavLink
                          exact
                          to={`${baseUrl}/site-engineer-list`}
                          onClick={handleRemove}
                        >
                          {localization.manageSiteEngineer}
                        </NavLink>
                      </li>
                    )}
                  </ul>
                </li>
              </>
            )}
            {departmentId.includes(3) && teamId.includes(2) && (
              <>
                <li className={`treeview ${active === true ? "active" : ""}`}>
                  <Link to="#" onClick={() => handleActive(!active)}>
                    {localization.maintenance}
                  </Link>
                  <ul
                    className={`treeview-menu ${
                      active === true ? "d-block" : ""
                    }`}
                  >
                    <li>
                      <NavLink
                        exact
                        to={`${baseUrl}/go-live-site`}
                        //  onClick={handleRemove}
                        onClick={() => handleRemoveNew("mainSiteCont")}
                      >
                        {localization.goLiveSites}
                      </NavLink>
                    </li>

                    {!role.includes(16) && (
                      <li>
                        <NavLink
                          exact
                          to={`${baseUrl}/site-asset-mapping`}
                          onClick={() => handleRemoveNew("siteAssetMapping")}
                        >
                          {localization.assetMapingOld}
                        </NavLink>
                      </li>
                    )}

                    {(role.includes(16) ||
                      role.includes(10) ||
                      role.includes(17)) && (
                      <li>
                        <NavLink
                          exact
                          to={`${baseUrl}/brand-activation/site-maintenance-user`}
                          onClick={() => handleRemoveNew("maintenanceSite")}
                          // onClick={handleRemove}
                        >
                          {localization.siteMaintenance}
                        </NavLink>
                      </li>
                    )}

                    <li>
                      <NavLink
                        exact
                        to={`${baseUrl}/site-listing-maintenance`}
                        // onClick={handleRemove}
                        onClick={() => handleRemoveNew("mainSiteCont")}
                      >
                        {localization.contractListing}
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        exact
                        to={`${baseUrl}/tasks_engg`}
                        //  onClick={handleRemove}
                        onClick={() => handleRemoveNew("networkEngineerTask")}
                      >
                        {localization.networkEngineerTask}
                      </NavLink>
                    </li>
                    {isRoleId == 9 && (
                      <>
                        <li>
                          <NavLink
                            exact
                            to={`${baseUrl}/site-listing-engg`}
                            //  onClick={handleRemove}
                            onClick={() => handleRemoveNew("projectUpdates")}
                          >
                            {localization.projectsUpdates}
                          </NavLink>
                        </li>
                      </>
                    )}

                    <li
                      className={`treeview ${
                        pmActive === true ? "d-block" : ""
                      }`}
                    >
                      <Link to="#" onClick={() => handlePmActive(!pmActive)}>
                        {localization.preventiveMaintenance}
                      </Link>
                      <ul
                        className={`treeview-menu ${
                          pmActive === true ? "d-block" : ""
                        }`}
                      >
                        <li>
                          <NavLink
                            exact
                            to={`${baseUrl}/pm-projects`}
                            //  onClick={handleRemove}
                            onClick={() => handleRemoveNew("pmSiteCont")}
                          >
                            {localization.pmSities}
                          </NavLink>
                        </li>
                        <li>
                          <NavLink
                            exact
                            to={`${baseUrl}/pm-software-sites`}
                            // onClick={handleRemove}
                            onClick={() => handleRemoveNew("pmSoftwareSites")}
                          >
                            {localization.PmSoftwareMaintenanceSites}
                          </NavLink>
                        </li>
                        {/* <li>
                         <NavLink
                           exact
                           to={`${baseUrl}/pm-tickets`}
                           onClick={handleRemove}
                         >
                           {localization.pmTickets}
                         </NavLink>
                       </li> */}
                      </ul>
                    </li>
                    <li>
                      <NavLink
                        exact
                        to={`${baseUrl}/rm-tickets`}
                        //  onClick={handleRemove}
                        onClick={() => handleRemoveNew("rmTicketCont")}
                      >
                        {localization.reactiveMaintenance}
                      </NavLink>
                    </li>

                    <li>
                      <NavLink
                        exact
                        to={`${baseUrl}/software-rm-tickets`}
                        // onClick={handleRemove}
                      >
                        {`RM Software`}
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        exact
                        to={`${baseUrl}/hardware-rm-tickets`}
                        // onClick={handleRemove}
                      >
                        {`RM Hardware`}
                      </NavLink>
                    </li>

                    {/* <li>
                     <NavLink
                       exact
                       to={`${baseUrl}/employee-ticket-list`}
                       onClick={handleRemove}
                     >
                       {localization.employeeTickets}
                     </NavLink>
                   </li> */}

                    {!role.includes(9) && (
                      <li
                        className={`treeview ${
                          approvalActive === true ? "d-block" : ""
                        }`}
                      >
                        <Link
                          to="#"
                          onClick={() => handleApprovalActive(!approvalActive)}
                        >
                          {localization.approvals}
                        </Link>
                        <ul
                          className={`treeview-menu ${
                            approvalActive === true ? "d-block" : ""
                          }`}
                        >
                          <li>
                            <NavLink
                              exact
                              to={`${baseUrl}/approvals/pm-sites`}
                              //  onClick={handleRemove}
                              onClick={() => handleRemoveNew("pmSiteCont")}
                            >
                              {localization.pmSities}
                            </NavLink>
                          </li>
                          <li>
                            <NavLink
                              exact
                              to={`${baseUrl}/approvals/pm-software-approve-report`}
                              //  onClick={handleRemove}
                              onClick={() => handleRemoveNew("pmSoftwareSites")}
                            >
                              {localization.PmSoftwareMaintenanceSites}
                            </NavLink>
                          </li>

                          {/* <li>
                           <NavLink
                             exact
                             to={`${baseUrl}/approvals/pm-tickets`}
                             onClick={handleRemove}
                           >
                             {localization.pmTickets}
                           </NavLink>
                         </li> */}

                          <li>
                            <NavLink
                              exact
                              to={`${baseUrl}/approvals/rm-tickets`}
                              //  onClick={handleRemove}
                              onClick={() => handleRemoveNew("rmTicketCont")}
                            >
                              {localization.rmTickets}
                            </NavLink>
                          </li>

                          <li>
                            <NavLink
                              exact
                              to={`${baseUrl}/approvals/employee-ticket-list`}
                              onClick={handleRemove}
                            >
                              {localization.employeeTickets}
                            </NavLink>
                          </li>
                        </ul>
                      </li>
                    )}
                    <li>
                      <NavLink
                        exact
                        to={`${baseUrl}/contract-assets-mapping`}
                        // onClick={handleRemove}
                      >
                        {`Asset Verification`}
                      </NavLink>
                    </li>
                  </ul>
                </li>
              </>
            )}
          </>
        </Fragment>
      )}

      {/* END OF NEW MENU */}

      {departmentId.includes(3) &&
        (teamId.includes(1) || teamId.includes(2)) &&
        (role.includes(8) || role.includes(10) || role.includes(16)) && (
          <li className={`treeview ${activeHoto === true ? "active" : ""}`}>
            <Link to="#" onClick={() => handleHotoActive(!activeHoto)}>
              {localization.hoto}
            </Link>
            <ul
              className={`treeview-menu ${
                activeHoto === true ? "d-block" : ""
              }`}
            >
              <li>
                <NavLink
                  exact
                  to={`${baseUrl}/hoto-i-listing/1/1`}
                  onClick={() => handleRemoveNew("hoto")}
                >
                  {localization.hotoInstListing}
                </NavLink>
              </li>
              <li>
                <NavLink
                  exact
                  to={`${baseUrl}/hoto-m-listing/2/1`}
                  // onClick={handleRemove}
                  onClick={() => handleRemoveNew("hoto")}
                >
                  {localization.hotoMainListing}
                </NavLink>
              </li>
              <li>
                <NavLink
                  exact
                  to={`${baseUrl}/hoto-i-approval/1/2`}
                  onClick={handleRemove}
                >
                  {localization.hotoInstApproval}
                </NavLink>
              </li>
              <li>
                <NavLink
                  exact
                  to={`${baseUrl}/hoto-m-approval/2/2`}
                  onClick={handleRemove}
                >
                  {localization.hotoMainApproval}
                </NavLink>
              </li>
            </ul>
          </li>
        )}

      {((role.includes(49) && userId.includes(605)) ||
        (role.includes(13) && userId.includes(1036)) ||
        (role.includes(13) && userId.includes(1218)) ||
        (role.includes(13) && userId.includes(1065))) && (
        <li className={`treeview ${creditData === true ? "active" : ""}`}>
          <Link to="#" onClick={() => handleCreditPolicy(!creditData)}>
            Credit Policy
          </Link>
          <ul
            className={`treeview-menu ${creditData === true ? "d-block" : ""}`}
          >
            <li>
              <NavLink
                exact
                to={`${baseUrl}/getCredits`}
                onClick={handlePageReload}
              >
                {localization.businessCredits}
              </NavLink>
            </li>
            <li>
              <NavLink
                exact
                to={`${baseUrl}/getEmployeeCredits`}
                onClick={handlePageReload}
              >
                {localization.employeeCredits}
              </NavLink>
            </li>
          </ul>
        </li>
      )}

      {role.includes(3) && userId.includes(833) && (
        <li>
          <NavLink
            exact
            to={`${baseUrl}/getCredits`}
            onClick={handlePageReload}
          >
            {localization.employeeCredits}
          </NavLink>
        </li>
      )}

      {/* {((role.includes(55) && userId.includes(905)) || 
          (role.includes(24) && userId.includes(622)) ||
          (role.includes(16) && userId.includes(99)) ||
          (role.includes(11) && userId.includes(123)) ||
          // (role.includes(16) && userId.includes(554)) ||
          (role.includes(3) && userId.includes(833)) ||
          (role.includes(3) && userId.includes(670)) || 
          (role.includes(65) && userId.includes(1012)) 
          // || (role.includes(65) && userId.includes(1202))
        ) && (
          <li>
            <NavLink exact to={`${baseUrl}/getCredits`} onClick={handlePageReload}>
              {localization.employeeCredits}
            </NavLink>
          </li>
        )} */}

      {(role.includes(8) ||
        role.includes(9) ||
        role.includes(10) ||
        role.includes(11) ||
        role.includes(12) ||
        role.includes(49) ||
        role.includes(83) ||
        role.includes(17)) && (
        <li className={`treeview ${activePR === true ? "active" : ""}`}>
          <Link to="#" onClick={() => handleActivePr(!activePR)}>
            {localization.servicePr}
          </Link>
          <ul className={`treeview-menu ${activePR === true ? "d-block" : ""}`}>
            {!role.includes(83) && (
              <li>
                <NavLink
                  exact
                  to={`${baseUrl}/service-pr-list`}
                  onClick={() => handleRemoveNew("mainSiteCont")}
                >
                  {localization.servicePrList}
                </NavLink>
              </li>
            )}

            {!role.includes(9) && !role.includes(17) && (
              <li>
                <NavLink
                  exact
                  to={`${baseUrl}/service-pr-approvals`}
                  onClick={() => handleRemoveNew("mainSiteCont")}
                >
                  {localization.prApprovals}
                </NavLink>
              </li>
            )}

            {(role.includes(83) ||
              role.includes(8) ||
              role.includes(9) ||
              role.includes(11) ||
              role.includes(17)) && (
              <li>
                <NavLink
                  exact
                  to={`${baseUrl}/jms-list`}
                  onClick={() => handleRemoveNew("mainSiteCont")}
                >
                  {localization.jmsApprovals}
                </NavLink>
              </li>
            )}
          </ul>
        </li>
      )}

      {departmentId.includes(3) &&
        (teamId.includes(1) || teamId.includes(2)) &&
        role.includes(9) && (
          <>
            <li className={`treeview ${activeHoto === true ? "active" : ""}`}>
              <Link to="#" onClick={() => handleHotoActive(!activeHoto)}>
                {localization.hoto}
              </Link>
              <ul
                className={`treeview-menu ${
                  activeHoto === true ? "d-block" : ""
                }`}
              >
                <li>
                  <NavLink
                    exact
                    to={`${baseUrl}/hoto-isite-listing/1`}
                    onClick={() => handleRemoveNew("hoto")}
                  >
                    {localization.hotoInstListing}
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    exact
                    to={`${baseUrl}/hoto-msite-listing/2`}
                    // onClick={handleRemove}
                    onClick={() => handleRemoveNew("hoto")}
                  >
                    {localization.hotoMainListing}
                  </NavLink>
                </li>
              </ul>
            </li>
          </>
        )}
      {departmentId.includes(3) && teamId.includes(4) && (
        <li className={`treeview ${baActive === true ? "active" : ""}`}>
          <Link to="#" onClick={() => handleBaActive(!baActive)}>
            {localization.brandActivation}
          </Link>
          <ul className={`treeview-menu ${baActive === true ? "d-block" : ""}`}>
            <li>
              <NavLink
                exact
                to={`${baseUrl}/ba-business-list`}
                // onClick={handleRemove}
                onClick={() => handleRemoveNew("baSiteCont")}
              >
                {localization.businessList}
              </NavLink>
            </li>
            <li>
              <NavLink
                exact
                to={`${baseUrl}/brand-activation/sites-listing`}
                // onClick={handleRemove}
                onClick={() => handleRemoveNew("baSiteCont")}
              >
                {localization.siteList}
              </NavLink>
            </li>
            <li>
              <NavLink
                exact
                to={`${baseUrl}/brand-activation/renewal-listing`}
                // onClick={handleRemove}
                onClick={() => handleRemoveNew("baSiteCont")}
              >
                {localization.renewlisting}
              </NavLink>
            </li>

            {role.includes(16) && teamId.includes(4) && (
              <li>
                <NavLink
                  exact
                  to={`${baseUrl}/brand-activation/file-meeting-upload-list`}
                  // onClick={handleRemove}
                  onClick={() => handleRemoveNew("planSchedule")}
                >
                  {localization.planSchedule}
                </NavLink>
              </li>
            )}
            <li>
              <NavLink
                exact
                to={`${baseUrl}/brand-activation/plan-schedule-list`}
                // onClick={handleRemove}
                onClick={() => handleRemoveNew("planScheduleList")}
              >
                {localization.planScheduleList}
              </NavLink>
            </li>
            <li>
              <NavLink
                exact
                to={`${baseUrl}/ncs-meetings`}
                onClick={() => handleRemoveNew("ncsMeetings")}
              >
                {localization.ncsMeetings}
              </NavLink>
            </li>
            {/* <li>
              <NavLink
                  exact
                  to={`${baseUrl}/contract-expiry/request-list`}
                  onClick={handleRemove}
                >
                  {'Renewal Request Approvals'}
                </NavLink>
            </li> */}
            <li>
              <NavLink
                exact
                to={`${baseUrl}/renew-approvals`}
                onClick={handleRemove}
              >
                {"Renewal Request Approvals"}
              </NavLink>
            </li>
            <li>
              <NavLink
                exact
                to={`${baseUrl}/competition-mapping-list`}
                onClick={handleRemove}
              >
                {localization.competitionMapping}
              </NavLink>
            </li>
            {/*<li>*/}
            {/*  <NavLink*/}
            {/*    exact*/}
            {/*    to={`${baseUrl}/brand-activation/scheduled-meeting`}*/}
            {/*    onClick={handleRemove}*/}
            {/*  >*/}
            {/*    {localization.meetingTracker}*/}
            {/*  </NavLink>*/}
            {/*</li>*/}
            {(role.includes(14) ||
              role.includes(56) ||
              role.includes(16) ||
              role.includes(15)) && (
              <li>
                <NavLink
                  exact
                  to={`${baseUrl}/brand-activation/feedback`}
                  onClick={handleRemove}
                >
                  {localization.feedBack}
                </NavLink>
              </li>
            )}
            {isRoleId !== null &&
              (isRoleId === STATUS.CITY_HEAD ||
                isRoleId === STATUS.NATIONAL_HEAD_OPERATIONS) && (
                <li className={`treeview ${approve === true ? "active" : ""}`}>
                  <Link to="#" onClick={() => handleApproveActive(!baActive)}>
                    {localization.approve}
                  </Link>
                  <ul
                    className={`treeview-menu ${
                      approve === true ? "d-block" : ""
                    }`}
                  >
                    <li>
                      <NavLink
                        exact
                        to={`${baseUrl}/brand-activation/conduct-camp/approval`}
                        onClick={handleRemove}
                      >
                        {localization.approveConductCamp}
                      </NavLink>
                    </li>
                  </ul>
                </li>
              )}

            {/* <li>
              <NavLink
                exact
                to={`${baseUrl}/brand-activation/products`}
                onClick={handleRemove}
              >
                {localization.products}
              </NavLink>
            </li> */}
            <li>
              <NavLink
                exact
                to={`${baseUrl}/rm-tickets-report`}
                // onClick={handleRemove}
                onClick={() => handleRemoveNew("rmTicketCont")}
              >
                {localization.rmReport}
              </NavLink>
            </li>
            <li>
              <NavLink
                exact
                to={`${baseUrl}/approvals/pm-site-state-approvals`}
                onClick={handleRemove}
              >
                {localization.pmSiteApproval}
              </NavLink>
            </li>
            {(userId.includes(188) ||
              userId.includes(99) ||
              userId.includes(867) ||
              userId.includes(34) ||
              userId.includes(36) ||
              userId.includes(110) ||
              userId.includes(138)) && (
              <li>
                <NavLink
                  exact
                  to={`${baseUrl}/renew-approvals`}
                  onClick={handleRemove}
                >
                  {localization.renewApproval}
                </NavLink>
              </li>
            )}
            {(role.includes(14) ||
              role.includes(15) ||
              role.includes(16) ||
              role.includes(17) ||
              role.includes(43)) && (
              <li>
                <NavLink
                  exact
                  to={`${baseUrl}/contract-expiry`}
                  onClick={handleRemove}
                >
                  {"Contract Expiry"}
                </NavLink>
              </li>
            )}

            {/* <li>
              <NavLink
                exact
                to={`${baseUrl}/brand-activation/knowledge-center`}
                onClick={handleRemove}
              >
                {localization.knowledgeCenter}
              </NavLink>
            </li> */}
          </ul>
        </li>
      )}

      {/* fraud check tabs starts */}
      {(departmentId.includes(3) ||
        departmentId.includes(4) ||
        departmentId.includes(5) ||
        departmentId.includes(8)) && (
        <li className={`treeview ${adsCampaign === true ? "active" : ""}`}>
          <Link to="#" onClick={() => handleAdsCampaign(!adsCampaign)}>
            {localization.adsSalesCampaign}
          </Link>
          <ul
            className={`treeview-menu ${adsCampaign === true ? "d-block" : ""}`}
          >
            {(departmentId.includes(3) || departmentId.includes(8)) && (
              <>
                {!role.includes(53) && !role.includes(33) && (
                  <li>
                    <NavLink
                      exact
                      to={`${baseUrl}/campaign-list`}
                      onClick={handleRemove}
                    >
                      {localization.campaignCreation}
                    </NavLink>
                  </li>
                )}
                {role.includes(16) || role.includes(24) ? (
                  <li>
                    <NavLink
                      exact
                      to={`${baseUrl}/manager-pending-list`}
                      onClick={handleRemove}
                    >
                      {localization.managerPendingList}
                    </NavLink>
                  </li>
                ) : null}
              </>
            )}
            {role.includes(53) && (
              <>
                <li>
                  <NavLink
                    exact
                    to={`${baseUrl}/l2-pending-list`}
                    onClick={handleRemove}
                  >
                    {localization.l2PendingList}
                  </NavLink>
                </li>
              </>
            )}
            {role.includes(33) && (
              <>
                <li>
                  <NavLink
                    exact
                    to={`${baseUrl}/finance-list`}
                    onClick={handleRemove}
                  >
                    {localization.financeList}
                  </NavLink>
                </li>
              </>
            )}
          </ul>
        </li>
      )}
      {/* fraud check works ends */}

      {departmentId.includes(3) && teamId.includes(4) && (
        <Fragment>
          {/* <li>
            <NavLink
              exact
              to={`${baseUrl}/brand-activation/conduct-carnival/carnival`}
              onClick={handleRemove}
            >
              {localization.carnivalListing}
            </NavLink>
          </li>
          <li>
            <NavLink
              exact
              to={`${baseUrl}/brand-activation/helpdesk`}
              onClick={handleRemove}
            >
              {localization.helpdeskListing}
            </NavLink>
          </li> */}

          <li>
            <NavLink
              exact
              to={`${baseUrl}/brand-activation/conduct-normal/list-normal`}
              onClick={handleRemove}
            >
              {localization.normalOnboardingListing}
            </NavLink>
          </li>

          {/* <li>
            <NavLink
              exact
              to={`${baseUrl}/brand-activation/knowledge-center`}
              onClick={handleRemove}
            >
              {localization.knowledgeCenter}
            </NavLink>
          </li> */}
          {/* <li>
            <NavLink
              exact
              to={`${baseUrl}/brand-activation/invoice`}
              onClick={handleRemove}
            >
              {localization.invoice}
            </NavLink>
          </li> */}
        </Fragment>
      )}

      {/* city head & NHOPS */}
      {departmentId.includes(3) && teamId.includes(1) && (
        <Fragment>
          {isRoleId !== null &&
            (isRoleId === STATUS.CITY_HEAD ||
              isRoleId === STATUS.NATIONAL_HEAD_OPERATIONS) && (
              <li
                className={`treeview ${
                  approveLocation === true ? "active" : ""
                }`}
              >
                <Link to="#" onClick={() => handleApproveLocation(!active)}>
                  {localization.approvals}
                </Link>
                <ul
                  className={`treeview-menu ${
                    approveLocation === true ? "d-block" : ""
                  }`}
                >
                  <li>
                    <NavLink
                      exact
                      to={`${baseUrl}/location-approvals`}
                      onClick={handleRemove}
                    >
                      {localization.locationApprovals}
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      exact
                      to={`${baseUrl}/abort-site-approvals`}
                      onClick={handleRemove}
                    >
                      {localization.siteAbortApproval}
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      exact
                      to={`${baseUrl}/mrf-approvals`}
                      onClick={handleRemove}
                    >
                      {localization.mrfApprovals}
                    </NavLink>
                  </li>
                </ul>
              </li>
            )}
        </Fragment>
      )}
      {/* Helpdesk starts */}
      <Fragment>
        {
          <li className={`treeview ${helpdesk === true ? "active" : ""}`}>
            <Link to="#" onClick={() => handleHelpdesk(!active)}>
              {localization.helpdesk}
            </Link>
            <ul
              className={`treeview-menu ${helpdesk === true ? "d-block" : ""}`}
            >
              {role.includes(13) && (
                <>
                  {/* user configuration list */}
                  <li>
                    <NavLink
                      exact
                      to={`${baseUrl}/helpdesk-listing`}
                      onClick={handleRemove}
                    >
                      {localization.config}
                    </NavLink>
                  </li>
                  {/* back to modification  list */}
                  <li>
                    <NavLink
                      exact
                      to={`${baseUrl}/approved-rejected-list`}
                      onClick={handleRemove}
                    >
                      {"Approved + Rejected List"}
                    </NavLink>
                  </li>
                  {/* finance pending approval list */}
                  <li>
                    <NavLink
                      exact
                      to={`${baseUrl}/finance-request-pending`}
                      onClick={handleRemove}
                    >
                      {localization.pendingRequest}
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      exact
                      to={`${baseUrl}/back-modification-request`}
                      onClick={handleRemove}
                    >
                      {"Send Back to Modification Request"}
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      exact
                      to={`${baseUrl}/procurement/hsn-list`}
                      onClick={handleRemove}
                    >
                      {`HSN / SAC`}
                    </NavLink>
                  </li>
                </>
              )}

              {!role.includes(13) && (
                <>
                  {/*user request pending list*/}
                  <li>
                    <NavLink
                      exact
                      to={`${baseUrl}/user-request-list`}
                      onClick={handleRemove}
                    >
                      {localization.userRequest}
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      exact
                      to={`${baseUrl}/user-request-pending`}
                      onClick={handleRemove}
                    >
                      {"Manager Request pending List"}
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      exact
                      to={`${baseUrl}/manager-approved-rejected-list`}
                      onClick={handleRemove}
                    >
                      {"Manager Approved + Rejected List"}
                    </NavLink>
                  </li>
                  {/* user request approval */}
                  <li>
                    <NavLink
                      exact
                      to={`${baseUrl}/helpdesk-hierarchy-list`}
                      onClick={handleRemove}
                    >
                      {localization.hierarchyList}
                    </NavLink>
                  </li>
                </>
              )}
            </ul>
          </li>
        }
      </Fragment>
      {/* Helpdesk ends */}
      {role.includes(18) && (
        <li className={`treeview ${activeComplain === true ? "active" : ""}`}>
          <Link to="#" onClick={() => handleActiveComplain(!activeComplain)}>
            {localization.fileComplain}
          </Link>
          <ul
            className={`treeview-menu ${
              activeComplain === true ? "d-block" : ""
            }`}
          >
            <li className={`${activeLink === true ? "active" : ""}`}>
              <NavLink
                exact
                to={`${baseUrl}/file-complain`}
                onClick={handleRemove}
              >
                {localization.createComplain}
              </NavLink>
            </li>
            <li className={`${activeLink === true ? "active" : ""}`}>
              <NavLink
                exact
                to={`${baseUrl}/complains-list`}
                // onClick={handleRemove}
                onClick={() => handleRemoveNew("complaintCont")}
              >
                {localization.complainList}
              </NavLink>
            </li>
          </ul>
        </li>
      )}

      <li className={`treeview ${activeTicket === true ? "active" : ""}`}>
        <Link to="#" onClick={() => handleActiveTickets(!activeTicket)}>
          {`Ticket List`}
        </Link>
        <ul
          className={`treeview-menu ${activeTicket === true ? "d-block" : ""}`}
        >
          {departmentId.includes(3) && (
            <>
              {(role.includes(53) || role.includes(61)) && (
                <>
                  <li>
                    <NavLink
                      exact
                      to={`${baseUrl}/complains-list-l2`}
                      onClick={handleRemove}
                    >
                      {`Client Ticket List`}
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      exact
                      to={`${baseUrl}/raise-issue-list`}
                      onClick={handleRemove}
                    >
                      {`LeadX Ticket List`}
                    </NavLink>
                  </li>
                </>
              )}

              {(role.includes(9) ||
                role.includes(8) ||
                role.includes(10) ||
                role.includes(16) ||
                role.includes(17) ||
                role.includes(15) ||
                role.includes(14) ||
                role.includes(61) ||
                role.includes(27)) && (
                <>
                  <li>
                    <NavLink
                      exact
                      to={`${baseUrl}/central-tech-complain-list`}
                      onClick={handleRemove}
                    >
                      {`CTE Tickets`}
                    </NavLink>
                  </li>
                </>
              )}
            </>
          )}
          {!role.includes(18) && (
            <Fragment>
              <li>
                <NavLink
                  exact
                  to={`${baseUrl}/fd-tickets`}
                  onClick={handleRemove}
                >
                  {localization.freshdeskTickets}
                </NavLink>
              </li>
            </Fragment>
          )}
        </ul>
      </li>

      {(role.includes(11) || role.includes(12)) && (
        <li
          className={`treeview ${activeBusinessItems === true ? "active" : ""}`}
        >
          <Link
            to="#"
            onClick={() => handleActiveBusinessItems(!activeBusinessItems)}
          >
            {`Business Items`}
          </Link>
          <ul
            className={`treeview-menu ${
              activeBusinessItems === true ? "d-block" : ""
            }`}
          >
            <>
              <li>
                <NavLink
                  exact
                  to={`${baseUrl}/procurement/brand-list`}
                  onClick={handleRemove}
                >
                  {`Brand`}
                </NavLink>
              </li>
              <li>
                <NavLink
                  exact
                  to={`${baseUrl}/procurement/category-list`}
                  onClick={handleRemove}
                >
                  {`Category`}
                </NavLink>
              </li>
              <li>
                <NavLink
                  exact
                  to={`${baseUrl}/procurement/business-materials`}
                  onClick={handleRemove}
                >
                  {`Materials`}
                </NavLink>
              </li>
              <li>
                <NavLink
                  exact
                  to={`${baseUrl}/procurement/business-services`}
                  onClick={handleRemove}
                >
                  {`Services`}
                </NavLink>
              </li>
            </>
          </ul>
        </li>
      )}

      {(userId.includes(8) ||
        userId.includes(220) ||
        userId.includes(1218)) && (
        <li>
          <NavLink
            exact
            to={`${baseUrl}/procurement/mrf-types`}
            onClick={handlePageReload}
          >
            {localization.MrfTypes}
          </NavLink>
        </li>
      )}

      {(role.includes(11) || role.includes(12)) && (
        <li>
          <NavLink
            exact
            to={`${baseUrl}/contract-listing`}
            onClick={handleRemove}
          >
            {localization.financeContract}
          </NavLink>
        </li>
      )}

      {(departmentId.includes(3) || departmentId.includes(2)) &&
        !teamId.includes(4) &&
        !role.includes(18) && (
          <Fragment>
            {/* <li>
              <NavLink
                exact
                to={`${baseUrl}/ticket-listing`}
                onClick={handleRemove}
              >
                {localization.tickets}
              </NavLink>
            </li> */}
          </Fragment>
        )}
      {siteInfoFeature === 1 && (
        <li className={`treeview ${locationActive === true ? "d-block" : ""}`}>
          <Link to="#" onClick={() => handleLocationActive(!locationActive)}>
            Site Location
          </Link>
          <ul
            className={`treeview-menu ${
              locationActive === true ? "d-block" : ""
            }`}
          >
            <li className={`treeview ${mapActive === true ? "d-block" : ""}`}>
              <Link to="#" onClick={() => handleMapActive(!mapActive)}>
                {localization.sitesLocationMapping}
              </Link>
              <ul
                className={`treeview-menu ${
                  mapActive === true ? "d-block" : ""
                }`}
              >
                <li>
                  <NavLink
                    exact
                    to={`${baseUrl}/sites-location-map`}
                    onClick={handleRemove}
                  >
                    {localization.sitesMap}
                  </NavLink>
                </li>
              </ul>

              {/* <li>
                <NavLink
                  exact
                  to={`${baseUrl}/employee-create-ticket`}
                  onClick={handleRemove}
                >
                  {localization.createEmployeeTicket}
                </NavLink>
              </li> */}
            </li>
          </ul>
        </li>
      )}

      {/* MRF */}
      <li className={`treeview ${activeMRF === true ? "active" : ""}`}>
        <Link to="#" onClick={() => handleActiveMRF(!activeMRF)}>
          {`MRF`}
        </Link>
        <ul className={`treeview-menu ${activeMRF === true ? "d-block" : ""}`}>
          <li>
            <NavLink
              exact
              to={`${baseUrl}/mrf-listing/2`}
              onClick={handlePageReload}
            >
              {localization.MaterialRequirement}
            </NavLink>
          </li>
          <li>
            <NavLink
              exact
              to={`${baseUrl}/employee-mrf`}
              onClick={handlePageReload}
            >
              {localization.empMrf}
            </NavLink>
          </li>
          <li>
            <NavLink
              exact
              to={`${baseUrl}/material-receiving`}
              onClick={handlePageReload}
            >
              {localization.materialReceive}
            </NavLink>
          </li>
          <li>
            <NavLink
              exact
              to={`${baseUrl}/mrf-approval-listing/1`}
              onClick={handlePageReload}
            >
              {localization.materialApproval}
            </NavLink>
          </li>
          <li>
            <NavLink
              exact
              to={`${baseUrl}/sales-order-return-mrf`}
              onClick={handlePageReload}
            >
              {localization.salesOrderReturn}
            </NavLink>
          </li>
        </ul>
      </li>

      {/* END MRF */}

      {role.includes(16) && (
        <li>
          <NavLink
            exact
            to={`${baseUrl}/user-credit-limit-list`}
            onClick={handlePageReload}
          >
            {localization.increaseCreditLimit}
          </NavLink>
        </li>
      )}

      <li>
        <NavLink exact to={`${baseUrl}/cl-ledger`} onClick={handlePageReload}>
          {localization.creditLimitLedger}
        </NavLink>
      </li>
      {(role.includes(38) || teamId.includes(15)) && (
        <li>
          <NavLink
            exact
            to={`${baseUrl}/image-compression`}
            onClick={handleRemove}
          >
            {localization.imageCompression}
          </NavLink>
        </li>
      )}
      <li>
        <NavLink
          exact
          to={`${baseUrl}/unclaimed-listing`}
          onClick={handlePageReload}
        >
          {localization.UnclaimedTransaction}
        </NavLink>
      </li>
      {(userId.includes(181) ||
        userId.includes(129) ||
        userId.includes(138)) && (
        <li>
          <NavLink
            exact
            to={`${baseUrl}/renew-approvals`}
            onClick={handleRemove}
          >
            {localization.renewApproval}
          </NavLink>
        </li>
      )}

      {/* {(role.includes(20) || role.includes(17) || role.includes(11) || role.includes(16) || role.includes(13) || role.includes(4)) && */}

      {/* } */}
      {/* <li>
        <NavLink
          exact
          to={`${baseUrl}/project-onboarding/add-project`}
          onClick={handleRemove}
        >
          {localization.projectOnboard}
        </NavLink>
      </li> */}

      {/* WALLET DROPDOWN */}
      {(role.includes(45) ||
        role.includes(44) ||
        role.includes(13) ||
        role.includes(7) ||
        role.includes(3) ||
        role.includes(49) ||
        role.includes(51) ||
        role.includes(52) ||
        role.includes(24) ||
        role.includes(25) ||
        role.includes(47) ||
        role.includes(26)) && (
        <li className={`treeview ${activeWallet === true ? "active" : ""}`}>
          <Link to="#" onClick={() => handleWalletActive(!activeWallet)}>
            {localization.wallet}
          </Link>
          <ul
            className={`treeview-menu ${
              activeWallet === true ? "d-block" : ""
            }`}
          >
            {(role.includes(45) ||
              role.includes(7) ||
              role.includes(51) ||
              role.includes(25) ||
              role.includes(26)) && (
              <>
                <li>
                  <NavLink
                    exact
                    to={`${baseUrl}/internal-wallet-list`}
                    onClick={handleRemove}
                  >
                    {localization.internalWallet}
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    exact
                    to={`${baseUrl}/external-wallet-list`}
                    onClick={handleRemove}
                  >
                    {localization.externalWallet}
                  </NavLink>
                </li>
              </>
            )}
            {(role.includes(44) ||
              role.includes(13) ||
              role.includes(3) ||
              role.includes(49) ||
              role.includes(52) ||
              role.includes(24) ||
              role.includes(47)) && (
              <li>
                <NavLink
                  exact
                  to={`${baseUrl}/wallet-approval-listing`}
                  onClick={handleRemove}
                >
                  {localization.walletApproval}
                </NavLink>
              </li>
            )}
            {/* {!role.includes(13) &&
            <li>
                <NavLink
                    exact
                    to={`${baseUrl}/dealer-request-approval`}
                    onClick={handleRemove}
                >
                  {localization.approvals}
                </NavLink>
              </li>
          } */}
            {role.includes(13) && (
              <li>
                <NavLink
                  exact
                  to={`${baseUrl}/dealer-finance-approval`}
                  onClick={handleRemove}
                >
                  {localization.walletApprovalDealer}
                </NavLink>
              </li>
            )}
            {role.includes(49) && (
              <>
                <li>
                  <NavLink
                    exact
                    to={`${baseUrl}/wallet-request-listing`}
                    onClick={handleRemove}
                  >
                    {localization.requestList}
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    exact
                    to={`${baseUrl}/request-internal-listing`}
                    onClick={handleRemove}
                  >
                    {localization.internalWallet}
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    exact
                    to={`${baseUrl}/request-external-listing`}
                    onClick={handleRemove}
                  >
                    {localization.externalWallet}
                  </NavLink>
                </li>
              </>
            )}
          </ul>
        </li>
      )}

      {/* WALLET END */}

      {/* RATING STARTS */}

      <li className={`treeview ${rating === true ? "active" : ""}`}>
        <Link to="#" onClick={() => handleRating(!rating)}>
          {localization.rating}
        </Link>
        <ul className={`treeview-menu ${rating === true ? "d-block" : ""}`}>
          {/* {isRoleId !== null &&
              (isRoleId === STATUS.SALES_COORDINATOR ||
                isRoleId === STATUS.NATIONAL_HEAD) && ( */}
          <>
            {isRoleId !== null && isRoleId === 16 && (
              <li>
                <NavLink
                  exact
                  to={`${baseUrl}/brand-activation/users-rating`}
                  onClick={handleRemove}
                >
                  {localization.userRating}
                </NavLink>
              </li>
            )}
            {isRoleId !== null &&
              (isRoleId === 14 || isRoleId === 17 || isRoleId === 56) && (
                <li>
                  <NavLink
                    exact
                    to={`${baseUrl}/brand-activation/meetings-rating`}
                    onClick={handleRemove}
                  >
                    {localization.meetingRating}
                  </NavLink>
                </li>
              )}

            <li>
              <NavLink
                exact
                to={`${baseUrl}/brand-activation/score-card-by-hod`}
                onClick={handleRemove}
              >
                {localization.hodScorecard}
              </NavLink>
            </li>
            <li>
              <NavLink
                exact
                to={`${baseUrl}/brand-activation/score-card-by-senior`}
                onClick={handleRemove}
              >
                {localization.seniorScorecard}
              </NavLink>
            </li>
          </>
          {/* )} */}
        </ul>
      </li>
      {/* RATING ENDS */}

      {departmentId.includes(3) &&
        (teamId.includes(4) || teamId.includes(2) || teamId.includes(1)) && (
          <li>
            <NavLink
              exact
              to={`${baseUrl}/brand-activation/scheduled-meeting`}
              onClick={handleRemove}
            >
              {localization.meetingTracker}
            </NavLink>
          </li>
        )}

      <li>
        <NavLink exact to={`${baseUrl}/tag-search`} onClick={handleRemove}>
          {localization.searchTag}
        </NavLink>
      </li>
      <li>
        <NavLink exact to={`${baseUrl}/site-visit-list`} onClick={handleRemove}>
          {localization.siteVisitTask}
        </NavLink>
      </li>
      {(role.includes(26) || role.includes(47)) && (
        <li>
          <NavLink exact to={`${baseUrl}/device-delink`} onClick={handleRemove}>
            {localization.deviceDelink}
          </NavLink>
        </li>
      )}

      {/* {(role.includes(14) || role.includes(15)) &&
            <li>
            <NavLink
              exact
              to={`${baseUrl}/tag-search`}
              onClick={handleRemove}
            >
              {localization.searchTag}
            </NavLink>
          </li>
      } */}

      {(role.includes(54) || role.includes(42)) && (
        <li>
          <NavLink exact to={`${baseUrl}/dealer-wallet`} onClick={handleRemove}>
            {localization.dealerWallet}
          </NavLink>
        </li>
      )}

      {role.includes(55) && (
        <li>
          <NavLink
            exact
            to={`${baseUrl}/dealer-request-approval`}
            onClick={handleRemove}
          >
            {localization.walletDealerApproval}
          </NavLink>
        </li>
      )}

      {/* eslint-disable-next-line no-mixed-operators */}
      {(role.includes(14) ||
        role.includes(15) ||
        role.includes(56) ||
        role.includes(16) ||
        role.includes(17) ||
        parseInt(departmentId) === 3) && (
        <>
          <li>
            <a href={"https://leadx-new.parkplus.io/"} target="_blank">
              {" "}
              {localization.fission}
            </a>
          </li>
        </>
      )}

      {(role.includes(58) ||
        role.includes(59) ||
        role.includes(60) ||
        role.includes(63) ||
        role.includes(85)) && (
        <>
          <li>
            <NavLink
              exact
              to={`${baseUrl}/cx-refund-request`}
              onClick={handleRemove}
            >
              {localization.CxRefundApproval}
            </NavLink>
          </li>
        </>
      )}

      <li>
        <NavLink
          exact
          to={`${baseUrl}/invoice-validation-list`}
          onClick={handleRemove}
        >
          {localization.InvoiceValidation}
        </NavLink>
      </li>
      {(role.includes(46) || role.includes(16)) && (
        <>
          <Fragment>
            {
              <li
                className={`treeview ${
                  activeValetServiceLineItem === true ? "active" : ""
                }`}
              >
                <Link
                  to="#"
                  onClick={() => handleActiveValetServiceLineItem(!active)}
                >
                  {localization.valetServicesLineItems}
                </Link>
                <ul
                  className={`treeview-menu ${
                    activeValetServiceLineItem === true ? "d-block" : ""
                  }`}
                >
                  {role.includes(46) && (
                    <>
                      <li>
                        <NavLink
                          exact
                          to={`${baseUrl}/valet-variable-invoice-list`}
                          onClick={handleRemove}
                        >
                          {localization.VariableValetInvoice}
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          exact
                          to={`${baseUrl}/valet-Fixed-invoice-list`}
                          onClick={handleRemove}
                        >
                          {localization.FixedValetInvoice}
                        </NavLink>
                      </li>
                    </>
                  )}

                  {role.includes(16) && (
                    <>
                      {/*user request pending list*/}
                      <li>
                        <NavLink
                          exact
                          to={`${baseUrl}/valet-approval-invoice-list`}
                          onClick={handleRemove}
                        >
                          {localization.VariableValetInvoice}
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          exact
                          to={`${baseUrl}/valet-Fixed-invoice-list`}
                          onClick={handleRemove}
                        >
                          {localization.FixedValetInvoice}
                        </NavLink>
                      </li>
                    </>
                  )}
                </ul>
              </li>
            }
          </Fragment>
        </>
      )}

      <Fragment>
        {
          <li
            className={`treeview ${serviceLineItem === true ? "active" : ""}`}
          >
            <Link to="#" onClick={() => handletServiceLineItem(!active)}>
              {"Invoice List"}
            </Link>
            <ul
              className={`treeview-menu ${
                serviceLineItem === true ? "d-block" : ""
              }`}
            >
              <>
                <li>
                  <NavLink
                    exact
                    to={`${baseUrl}/variable-service-invoice-list`}
                    onClick={handleRemove}
                  >
                    {"Variable Invoice List"}
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    exact
                    to={`${baseUrl}/capex-invoice-list`}
                    onClick={handleRemove}
                  >
                    {"Capex Invoice List"}
                  </NavLink>
                </li>
                {/* <li>
                        <NavLink
                          exact
                          to={`${baseUrl}/service-fixed-invoice-list`}
                          onClick={handleRemove}
                        >
                          {'Fixed Invoice List'}
                        </NavLink>
                      </li> */}
              </>
            </ul>
          </li>
        }
      </Fragment>
      {role.includes(67) && (
        <li className={`treeview ${active === true ? "active" : ""}`}>
          <Link to="#" onClick={() => handleActive(!active)}>
            {"FasTag"}
          </Link>
          <ul className={`treeview-menu ${active === true ? "d-block" : ""}`}>
            <li>
              <NavLink
                exact
                to={`${baseUrl}/fastag-pricing`}
                onClick={handleRemove}
              >
                {"Pricing/Inventory"}
              </NavLink>
            </li>
            <li>
              <NavLink
                exact
                to={`${baseUrl}/toa-tag-orders`}
                onClick={handleRemove}
              >
                {"TOA Tag Orders"}
              </NavLink>
            </li>
            <li>
              <NavLink
                exact
                to={`${baseUrl}/fastag-compliance`}
                onClick={handleRemove}
              >
                {"Fastag Compliance"}
              </NavLink>
            </li>
          </ul>
        </li>
      )}
      {role.includes(84) && (
        <li>
          <NavLink
            exact
            to={`${baseUrl}/fastag-compliance`}
            onClick={handleRemove}
          >
            {"Fastag Compliance"}
          </NavLink>
        </li>
      )}
    </Fragment>
  );
};

const mapStateToProps = (state) => {
  const userProfileData = state.loginReducer.userProfile;
  return {
    isRoleId:
      userProfileData.roles !== undefined &&
      userProfileData.roles[0].id,
    isJourneyStarted: !!userProfileData?.is_journey_started,
  };
};
export default connect(mapStateToProps, {})(DropDownLink);
// export default DropDownLink;
